// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  getScheduledDriveByVehicle,
  checkVehicleMaintenanceMode,
  submitStatus,
  submitVehicleVersions,
  submitParkingRecord,
  getParkingRecordResponse,
  submitRouteRecord,
  submitEvidencePackage,
  shouldSubmitEvidencePackage,
  submitSkippedRouteSegmentRecord,
  submitSignPostRecord,
  submitUnexpectedEvent,
  submitUnexpectedEventPackage,
  shouldSubmitUnexpectedEventPackage,
  submitVehiclePosition,
  getDriversAndScheduledShifts,
  getActiveWorkPeriod,
  driverSignIn,
  driverSignOut,
  reportDriveStarted,
  reportDriveFinished,
  getFinishedDriveStatistics,
  scheduleFreeride,
  postComputeRoutes,
  getEmptyTechnicalSegments,
  submitEmptyTechnicalSegmentEvidence,
  deleteEmptyTechnicalSegments,
  getAllPlanningAreas,
  deletePlanningArea,
  getPlanningArea,
  updatePlanningArea,
  createDistrict,
  getPlanningData,
  getDistrictMap,
  getAllActiveRoutes,
  getRouteProblemsSummary,
  getRoutesInArea,
  getRouteTsCoverageAll,
  getRouteTsCoverage,
  checkRouteWithGoogleMaps,
  validateStreetSegmentGeometry,
  deleteRoute,
  getRoute,
  createRoute,
  deleteRouteDrives,
  updateRouteFragments,
  autogenerateRouteFragments,
  getStreetSegmentsInPolygon,
  getDistrictPlanningData,
  getAllPlanningData,
  postPlanningDataInPolygon,
  getOverrideList,
  getSnapshotList,
  getSnapshotListWithOverrides,
  compareTwoSnapshots,
  getStreetSegments,
  getTskSegments,
  getRequirements,
  getRequirementsDocu,
  getControlDataSchemas,
  createMapSnapshot,
  getCurrentSnapshot,
  getControlDataDataVersion,
  syncMaps,
  deleteSnapshot,
  syncOpenstreetmaps,
  getStreetSegment,
  getTechnicalSegment,
  getRegulatedZone,
  getSignPost,
  getPlanningAreaSplits,
  savePlanningAreaSplits,
  getSplitsDistrictPlanningData,
  computeDistrictSplits,
  getDistrictsWithRequestedSegments,
  getPendingRecompute,
  getAllSplitProblems,
  getDsTariffRootMap,
  getDsDriveTimes,
  getDsDriveOverview,
  getDsBigClosures,
  getDsRouteMap,
  routesMapData,
  routesMapViewport,
  routesMapRouteDetail,
  routesMapSearch,
  updateStreetSegment,
  deleteStreetSegmentOverride,
  upsertStreetSegmentOverride,
  updateTechnicalSegment,
  updateRegulatedZone,
  updateSignPost,
  updateControlDataStructure,
  updateToOverrideBasedControlDataStructure,
  rollbackToLegacyControlDataStructure,
  copyAndUpdateControlDataStructure,
  importTechnicalSegmentsRegulatedZonesAndSignPosts,
  freezeTechnicalSegmentStreetPairing,
  pairTechnicalSegments2StreetSegments,
  computeSsdr,
  compareRows,
  applyCompareChange,
  pullControlData,
  deleteControlDataSchema,
  getAllVehicles,
  getVehicle,
  updateVehicle,
  getVehicleLastStatus,
  getVehicleMetrics,
  getVehicleNavigationData,
  setVehicleMaintenanceMode,
  getAllDrivers,
  createDriver,
  getExternalDrivers,
  importExternalDriver,
  associateExternalDriver,
  getDriver,
  updateDriver,
  getInactiveDrivers,
  getDailySchedule,
  getScheduleForInterval,
  getShiftOverview,
  deleteShift,
  getScheduledDrives,
  scheduleDrive,
  getScheduledDrive,
  updateScheduledDrive,
  reorderScheduledDrives,
  rescheduleDrive,
  moveSchedule,
  getCurrentDrives,
  cancelScheduledDrive,
  approveScheduledDrive,
  disapproveScheduledDrive,
  getDriveIntervals,
  getRequirementSubintervals,
  getRequirementFulfillmentPerSegment,
  getRequirementFulfillment,
  syncShiftsOnDemand,
  getPingVehicle,
  populateInterval,
  manuallyPopulateInterval,
  scheduleDistricts,
  copyVehicleSchedule,
  scheduleDocumentationDay,
  scheduleDocumentationMonth,
  scheduleItstDay,
  scheduleItstMonth,
  applyDsPlanEndpoint,
  getDrivesByDate,
  getDailyDriveOverview,
  getScheduledDriveStatistics,
  getPackageSubmissionDetail,
  getDetailedDriveStatistics,
  getDriverStatistics,
  getElapsedDriverTime,
  getAllRouteStatistics,
  getDistrictOverheadStatistics,
  getRouteStatistics,
  getOperationMetrics,
  getOperationReportDrivers,
  getOperationReportRoutes,
  getDetectionComparisonFirstDrives,
  getDetectionComparisonSecondDrives,
  getDetectionComparison,
  getDriveEvents,
  getDrivenStreetSegments,
  getParkingSignDetectionCount,
  getTechnicalSegmentDetectionCount,
  getDocumentationOverview,
  getSignPostConfidences,
  getTasks,
  getTasksForInterval,
  getAllBillingPeriods,
  createBillingPeriod,
  getTaskBillingPeriods,
  deleteBillingPeriod,
  getBillingPeriodDetail,
  updateBillingPeriod,
  updateBillingPeriodPrices,
  importOrder,
  getDriveBillingData,
  getBillingAuditData,
  getBilledAmountHistory,
  getInvoiceDetail,
  getInvoiceDetailCsv,
  getInvoiceCsv,
  getInvoiceCsvTotals,
  getStreetSegmentAuditData,
  getTechnicalSegmentAuditData,
  getInvoiceAttachmentZip,
  getMetrics,
  checkHealth,
  authenticateUser,
  refreshToken,
  introspectUser,
  changeOwnPassword,
  logEvidenceSubmission,
  getEventPayload,
  getPackageScores,
  getPassRequest,
  resubmitEvents,
  deprecatedGetMapSchemaSnapshotVersion,
  getControlDataVersion,
  getControlDataContents,
  deprecatedGetMapSchemaContents,
  getAllUnexpectedEvents,
  getPendingUnexpectedEvents,
  getArchivedUnexpectedEvents,
  getUnexpectedEventCameraCaptures,
  getUnexpectedEventDetails,
  getAnnexationsForDay,
  resolveUnexpectedEvent,
  unresolveUnexpectedEvent,
  getAffectedRoutes,
  getEnvInfo,
  cleanCache,
  cleanBillingCache,
  getHotlineCalls,
  getChunks,
  getChunkDetail,
  postChunkQuality,
  getImage,
  getReportCsv,
  listRoles,
  createRole,
  deleteRole,
  getRole,
  updateRole,
  listUsers,
  createUser,
  deleteUser,
  getUser,
  updateUser,
  pushReport,
} from '../sdk.gen'
import { queryOptions, type UseMutationOptions, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query'
import type {
  GetScheduledDriveByVehicleData,
  CheckVehicleMaintenanceModeData,
  SubmitStatusData,
  SubmitStatusError,
  SubmitStatusResponse,
  SubmitVehicleVersionsData,
  SubmitVehicleVersionsError,
  SubmitVehicleVersionsResponse,
  SubmitParkingRecordData,
  SubmitParkingRecordError,
  SubmitParkingRecordResponse,
  GetParkingRecordResponseData,
  SubmitRouteRecordData,
  SubmitRouteRecordError,
  SubmitRouteRecordResponse,
  SubmitEvidencePackageData,
  SubmitEvidencePackageError,
  SubmitEvidencePackageResponse,
  ShouldSubmitEvidencePackageData,
  SubmitSkippedRouteSegmentRecordData,
  SubmitSkippedRouteSegmentRecordError,
  SubmitSkippedRouteSegmentRecordResponse,
  SubmitSignPostRecordData,
  SubmitSignPostRecordError,
  SubmitSignPostRecordResponse,
  SubmitUnexpectedEventData,
  SubmitUnexpectedEventError,
  SubmitUnexpectedEventResponse,
  SubmitUnexpectedEventPackageData,
  SubmitUnexpectedEventPackageError,
  SubmitUnexpectedEventPackageResponse,
  ShouldSubmitUnexpectedEventPackageData,
  SubmitVehiclePositionData,
  SubmitVehiclePositionError,
  SubmitVehiclePositionResponse,
  GetDriversAndScheduledShiftsData,
  GetActiveWorkPeriodData,
  DriverSignInData,
  DriverSignInError,
  DriverSignInResponse,
  DriverSignOutData,
  DriverSignOutError,
  DriverSignOutResponse,
  ReportDriveStartedData,
  ReportDriveStartedError,
  ReportDriveStartedResponse,
  ReportDriveFinishedData,
  ReportDriveFinishedError,
  ReportDriveFinishedResponse,
  GetFinishedDriveStatisticsData,
  ScheduleFreerideData,
  ScheduleFreerideError,
  ScheduleFreerideResponse,
  PostComputeRoutesData,
  PostComputeRoutesError,
  PostComputeRoutesResponse,
  GetEmptyTechnicalSegmentsData,
  SubmitEmptyTechnicalSegmentEvidenceData,
  SubmitEmptyTechnicalSegmentEvidenceError,
  SubmitEmptyTechnicalSegmentEvidenceResponse,
  DeleteEmptyTechnicalSegmentsData,
  DeleteEmptyTechnicalSegmentsError,
  DeleteEmptyTechnicalSegmentsResponse,
  GetAllPlanningAreasData,
  DeletePlanningAreaData,
  DeletePlanningAreaError,
  DeletePlanningAreaResponse,
  GetPlanningAreaData,
  UpdatePlanningAreaData,
  UpdatePlanningAreaError,
  UpdatePlanningAreaResponse,
  CreateDistrictData,
  CreateDistrictError,
  CreateDistrictResponse,
  GetPlanningDataData,
  GetDistrictMapData,
  GetAllActiveRoutesData,
  GetRouteProblemsSummaryData,
  GetRoutesInAreaData,
  GetRouteTsCoverageAllData,
  GetRouteTsCoverageData,
  CheckRouteWithGoogleMapsData,
  ValidateStreetSegmentGeometryData,
  DeleteRouteData,
  DeleteRouteError,
  DeleteRouteResponse,
  GetRouteData,
  CreateRouteData,
  CreateRouteError,
  CreateRouteResponse,
  DeleteRouteDrivesData,
  DeleteRouteDrivesError,
  DeleteRouteDrivesResponse,
  UpdateRouteFragmentsData,
  UpdateRouteFragmentsError,
  UpdateRouteFragmentsResponse,
  AutogenerateRouteFragmentsData,
  AutogenerateRouteFragmentsError,
  AutogenerateRouteFragmentsResponse,
  GetStreetSegmentsInPolygonData,
  GetStreetSegmentsInPolygonError,
  GetStreetSegmentsInPolygonResponse,
  GetDistrictPlanningDataData,
  GetDistrictPlanningDataError,
  GetDistrictPlanningDataResponse,
  GetAllPlanningDataData,
  GetAllPlanningDataError,
  GetAllPlanningDataResponse,
  PostPlanningDataInPolygonData,
  PostPlanningDataInPolygonError,
  PostPlanningDataInPolygonResponse,
  GetOverrideListData,
  GetSnapshotListData,
  GetSnapshotListWithOverridesData,
  CompareTwoSnapshotsData,
  GetStreetSegmentsData,
  GetTskSegmentsData,
  GetRequirementsData,
  GetRequirementsDocuData,
  GetControlDataSchemasData,
  CreateMapSnapshotData,
  CreateMapSnapshotError,
  CreateMapSnapshotResponse,
  GetCurrentSnapshotData,
  GetControlDataDataVersionData,
  SyncMapsData,
  SyncMapsError,
  SyncMapsResponse,
  DeleteSnapshotData,
  DeleteSnapshotError,
  DeleteSnapshotResponse,
  SyncOpenstreetmapsData,
  SyncOpenstreetmapsError,
  SyncOpenstreetmapsResponse,
  GetStreetSegmentData,
  GetTechnicalSegmentData,
  GetRegulatedZoneData,
  GetSignPostData,
  GetPlanningAreaSplitsData,
  SavePlanningAreaSplitsData,
  SavePlanningAreaSplitsError,
  SavePlanningAreaSplitsResponse,
  GetSplitsDistrictPlanningDataData,
  GetSplitsDistrictPlanningDataError,
  GetSplitsDistrictPlanningDataResponse,
  ComputeDistrictSplitsData,
  ComputeDistrictSplitsError,
  ComputeDistrictSplitsResponse,
  GetDistrictsWithRequestedSegmentsData,
  GetPendingRecomputeData,
  GetAllSplitProblemsData,
  GetDsTariffRootMapData,
  GetDsDriveTimesData,
  GetDsDriveOverviewData,
  GetDsBigClosuresData,
  GetDsRouteMapData,
  RoutesMapDataData,
  RoutesMapViewportData,
  RoutesMapViewportError,
  RoutesMapViewportResponse2,
  RoutesMapRouteDetailData,
  RoutesMapSearchData,
  UpdateStreetSegmentData,
  UpdateStreetSegmentError,
  UpdateStreetSegmentResponse,
  DeleteStreetSegmentOverrideData,
  DeleteStreetSegmentOverrideError,
  DeleteStreetSegmentOverrideResponse,
  UpsertStreetSegmentOverrideData,
  UpsertStreetSegmentOverrideError,
  UpsertStreetSegmentOverrideResponse,
  UpdateTechnicalSegmentData,
  UpdateTechnicalSegmentError,
  UpdateTechnicalSegmentResponse,
  UpdateRegulatedZoneData,
  UpdateRegulatedZoneError,
  UpdateRegulatedZoneResponse,
  UpdateSignPostData,
  UpdateSignPostError,
  UpdateSignPostResponse,
  UpdateControlDataStructureData,
  UpdateControlDataStructureError,
  UpdateControlDataStructureResponse,
  UpdateToOverrideBasedControlDataStructureData,
  UpdateToOverrideBasedControlDataStructureError,
  UpdateToOverrideBasedControlDataStructureResponse,
  RollbackToLegacyControlDataStructureData,
  RollbackToLegacyControlDataStructureError,
  RollbackToLegacyControlDataStructureResponse,
  CopyAndUpdateControlDataStructureData,
  CopyAndUpdateControlDataStructureError,
  CopyAndUpdateControlDataStructureResponse,
  ImportTechnicalSegmentsRegulatedZonesAndSignPostsData,
  ImportTechnicalSegmentsRegulatedZonesAndSignPostsError,
  ImportTechnicalSegmentsRegulatedZonesAndSignPostsResponse,
  FreezeTechnicalSegmentStreetPairingData,
  FreezeTechnicalSegmentStreetPairingError,
  FreezeTechnicalSegmentStreetPairingResponse,
  PairTechnicalSegments2StreetSegmentsData,
  PairTechnicalSegments2StreetSegmentsError,
  PairTechnicalSegments2StreetSegmentsResponse,
  ComputeSsdrData,
  ComputeSsdrError,
  ComputeSsdrResponse,
  CompareRowsData,
  CompareRowsError,
  CompareRowsResponse2,
  ApplyCompareChangeData,
  ApplyCompareChangeError,
  ApplyCompareChangeResponse,
  PullControlDataData,
  PullControlDataError,
  PullControlDataResponse,
  DeleteControlDataSchemaData,
  DeleteControlDataSchemaError,
  DeleteControlDataSchemaResponse,
  GetAllVehiclesData,
  GetVehicleData,
  UpdateVehicleData,
  UpdateVehicleError,
  UpdateVehicleResponse,
  GetVehicleLastStatusData,
  GetVehicleMetricsData,
  GetVehicleNavigationDataData,
  SetVehicleMaintenanceModeData,
  SetVehicleMaintenanceModeError,
  SetVehicleMaintenanceModeResponse,
  GetAllDriversData,
  CreateDriverData,
  CreateDriverError,
  CreateDriverResponse,
  GetExternalDriversData,
  ImportExternalDriverData,
  ImportExternalDriverError,
  ImportExternalDriverResponse,
  AssociateExternalDriverData,
  AssociateExternalDriverError,
  AssociateExternalDriverResponse,
  GetDriverData,
  UpdateDriverData,
  UpdateDriverError,
  UpdateDriverResponse,
  GetInactiveDriversData,
  GetDailyScheduleData,
  GetScheduleForIntervalData,
  GetShiftOverviewData,
  DeleteShiftData,
  DeleteShiftError,
  DeleteShiftResponse,
  GetScheduledDrivesData,
  ScheduleDriveData,
  ScheduleDriveError,
  ScheduleDriveResponse,
  GetScheduledDriveData,
  UpdateScheduledDriveData,
  UpdateScheduledDriveError,
  UpdateScheduledDriveResponse,
  ReorderScheduledDrivesData,
  ReorderScheduledDrivesError,
  ReorderScheduledDrivesResponse,
  RescheduleDriveData,
  RescheduleDriveError,
  RescheduleDriveResponse,
  MoveScheduleData,
  MoveScheduleError,
  MoveScheduleResponse,
  GetCurrentDrivesData,
  CancelScheduledDriveData,
  CancelScheduledDriveError,
  CancelScheduledDriveResponse,
  ApproveScheduledDriveData,
  ApproveScheduledDriveError,
  ApproveScheduledDriveResponse,
  DisapproveScheduledDriveData,
  DisapproveScheduledDriveError,
  DisapproveScheduledDriveResponse,
  GetDriveIntervalsData,
  GetRequirementSubintervalsData,
  GetRequirementFulfillmentPerSegmentData,
  GetRequirementFulfillmentData,
  SyncShiftsOnDemandData,
  GetPingVehicleData,
  PopulateIntervalData,
  PopulateIntervalError,
  PopulateIntervalResponse,
  ManuallyPopulateIntervalData,
  ManuallyPopulateIntervalError,
  ManuallyPopulateIntervalResponse,
  ScheduleDistrictsData,
  ScheduleDistrictsError,
  ScheduleDistrictsResponse,
  CopyVehicleScheduleData,
  CopyVehicleScheduleError,
  CopyVehicleScheduleResponse,
  ScheduleDocumentationDayData,
  ScheduleDocumentationDayError,
  ScheduleDocumentationDayResponse,
  ScheduleDocumentationMonthData,
  ScheduleDocumentationMonthError,
  ScheduleDocumentationMonthResponse,
  ScheduleItstDayData,
  ScheduleItstDayError,
  ScheduleItstDayResponse,
  ScheduleItstMonthData,
  ScheduleItstMonthError,
  ScheduleItstMonthResponse,
  ApplyDsPlanEndpointData,
  ApplyDsPlanEndpointError,
  ApplyDsPlanEndpointResponse,
  GetDrivesByDateData,
  GetDailyDriveOverviewData,
  GetScheduledDriveStatisticsData,
  GetPackageSubmissionDetailData,
  GetDetailedDriveStatisticsData,
  GetDriverStatisticsData,
  GetElapsedDriverTimeData,
  GetAllRouteStatisticsData,
  GetDistrictOverheadStatisticsData,
  GetRouteStatisticsData,
  GetOperationMetricsData,
  GetOperationReportDriversData,
  GetOperationReportRoutesData,
  GetDetectionComparisonFirstDrivesData,
  GetDetectionComparisonFirstDrivesError,
  GetDetectionComparisonFirstDrivesResponse,
  GetDetectionComparisonSecondDrivesData,
  GetDetectionComparisonSecondDrivesError,
  GetDetectionComparisonSecondDrivesResponse,
  GetDetectionComparisonData,
  GetDriveEventsData,
  GetDrivenStreetSegmentsData,
  GetParkingSignDetectionCountData,
  GetTechnicalSegmentDetectionCountData,
  GetDocumentationOverviewData,
  GetSignPostConfidencesData,
  GetTasksData,
  GetTasksForIntervalData,
  GetAllBillingPeriodsData,
  CreateBillingPeriodData,
  CreateBillingPeriodError,
  CreateBillingPeriodResponse,
  GetTaskBillingPeriodsData,
  DeleteBillingPeriodData,
  DeleteBillingPeriodError,
  DeleteBillingPeriodResponse,
  GetBillingPeriodDetailData,
  UpdateBillingPeriodData,
  UpdateBillingPeriodError,
  UpdateBillingPeriodResponse,
  UpdateBillingPeriodPricesData,
  UpdateBillingPeriodPricesError,
  UpdateBillingPeriodPricesResponse,
  ImportOrderData,
  ImportOrderError2,
  ImportOrderResponse2,
  GetDriveBillingDataData,
  GetBillingAuditDataData,
  GetBilledAmountHistoryData,
  GetInvoiceDetailData,
  GetInvoiceDetailCsvData,
  GetInvoiceCsvData,
  GetInvoiceCsvTotalsData,
  GetStreetSegmentAuditDataData,
  GetTechnicalSegmentAuditDataData,
  GetInvoiceAttachmentZipData,
  GetMetricsData,
  CheckHealthData,
  AuthenticateUserData,
  AuthenticateUserError,
  AuthenticateUserResponse,
  RefreshTokenData,
  RefreshTokenError,
  RefreshTokenResponse,
  IntrospectUserData,
  ChangeOwnPasswordData,
  ChangeOwnPasswordError,
  ChangeOwnPasswordResponse,
  LogEvidenceSubmissionData,
  LogEvidenceSubmissionError,
  LogEvidenceSubmissionResponse,
  GetEventPayloadData,
  GetPackageScoresData,
  GetPassRequestData,
  ResubmitEventsData,
  ResubmitEventsError,
  ResubmitEventsResponse2,
  DeprecatedGetMapSchemaSnapshotVersionData,
  GetControlDataVersionData,
  GetControlDataContentsData,
  DeprecatedGetMapSchemaContentsData,
  GetAllUnexpectedEventsData,
  GetPendingUnexpectedEventsData,
  GetArchivedUnexpectedEventsData,
  GetUnexpectedEventCameraCapturesData,
  GetUnexpectedEventDetailsData,
  GetAnnexationsForDayData,
  ResolveUnexpectedEventData,
  ResolveUnexpectedEventError,
  UnresolveUnexpectedEventData,
  UnresolveUnexpectedEventError,
  GetAffectedRoutesData,
  GetAffectedRoutesError,
  GetAffectedRoutesResponse,
  GetEnvInfoData,
  CleanCacheData,
  CleanBillingCacheData,
  GetHotlineCallsData,
  GetChunksData,
  GetChunkDetailData,
  PostChunkQualityData,
  PostChunkQualityError,
  PostChunkQualityResponse,
  GetImageData,
  GetReportCsvData,
  ListRolesData,
  CreateRoleData,
  CreateRoleError,
  CreateRoleResponse,
  DeleteRoleData,
  DeleteRoleError,
  DeleteRoleResponse,
  GetRoleData,
  UpdateRoleData,
  UpdateRoleError,
  UpdateRoleResponse,
  ListUsersData,
  CreateUserData,
  CreateUserError,
  CreateUserResponse,
  DeleteUserData,
  DeleteUserError,
  DeleteUserResponse,
  GetUserData,
  UpdateUserData,
  UpdateUserError,
  UpdateUserResponse,
  PushReportData,
  PushReportError,
  PushReportResponse,
} from '../types.gen'
import { client as _heyApiClient } from './initializer'

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const getScheduledDriveByVehicleQueryKey = (options?: Options<GetScheduledDriveByVehicleData>) =>
  createQueryKey('getScheduledDriveByVehicle', options)

/**
 * Get Scheduled Drive By Vehicle
 * Get a drive currently scheduled for the authenticated vehicle.
 */
export const getScheduledDriveByVehicleOptions = (options?: Options<GetScheduledDriveByVehicleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScheduledDriveByVehicle({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getScheduledDriveByVehicleQueryKey(options),
  })
}

export const checkVehicleMaintenanceModeQueryKey = (options?: Options<CheckVehicleMaintenanceModeData>) =>
  createQueryKey('checkVehicleMaintenanceMode', options)

/**
 * Check Vehicle Maintenance Mode
 */
export const checkVehicleMaintenanceModeOptions = (options?: Options<CheckVehicleMaintenanceModeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await checkVehicleMaintenanceMode({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: checkVehicleMaintenanceModeQueryKey(options),
  })
}

export const submitStatusQueryKey = (options: Options<SubmitStatusData>) => createQueryKey('submitStatus', options)

/**
 * Submit Status
 * Submit status information for the patrol vehicle. The information is stored for a limited period of time.
 * This endpoint is expected to be called periodically, regardless of scheduled drives.
 */
export const submitStatusOptions = (options: Options<SubmitStatusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitStatusQueryKey(options),
  })
}

/**
 * Submit Status
 * Submit status information for the patrol vehicle. The information is stored for a limited period of time.
 * This endpoint is expected to be called periodically, regardless of scheduled drives.
 */
export const submitStatusMutation = (
  options?: Partial<Options<SubmitStatusData>>
): UseMutationOptions<SubmitStatusResponse, SubmitStatusError, Options<SubmitStatusData>> => {
  const mutationOptions: UseMutationOptions<SubmitStatusResponse, SubmitStatusError, Options<SubmitStatusData>> = {
    mutationFn: async localOptions => {
      const { data } = await submitStatus({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const submitVehicleVersionsQueryKey = (options: Options<SubmitVehicleVersionsData>) =>
  createQueryKey('submitVehicleVersions', options)

/**
 * Submit Vehicle Versions
 * Submit vehicle versions for the patrol vehicle.
 * This endpoint is expected to be called on vehicle startup/after update.
 */
export const submitVehicleVersionsOptions = (options: Options<SubmitVehicleVersionsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitVehicleVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitVehicleVersionsQueryKey(options),
  })
}

/**
 * Submit Vehicle Versions
 * Submit vehicle versions for the patrol vehicle.
 * This endpoint is expected to be called on vehicle startup/after update.
 */
export const submitVehicleVersionsMutation = (
  options?: Partial<Options<SubmitVehicleVersionsData>>
): UseMutationOptions<
  SubmitVehicleVersionsResponse,
  SubmitVehicleVersionsError,
  Options<SubmitVehicleVersionsData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitVehicleVersionsResponse,
    SubmitVehicleVersionsError,
    Options<SubmitVehicleVersionsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitVehicleVersions({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const submitParkingRecordQueryKey = (options: Options<SubmitParkingRecordData>) =>
  createQueryKey('submitParkingRecord', options)

/**
 * Submit Parking Record
 */
export const submitParkingRecordOptions = (options: Options<SubmitParkingRecordData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitParkingRecord({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitParkingRecordQueryKey(options),
  })
}

/**
 * Submit Parking Record
 */
export const submitParkingRecordMutation = (
  options?: Partial<Options<SubmitParkingRecordData>>
): UseMutationOptions<SubmitParkingRecordResponse, SubmitParkingRecordError, Options<SubmitParkingRecordData>> => {
  const mutationOptions: UseMutationOptions<
    SubmitParkingRecordResponse,
    SubmitParkingRecordError,
    Options<SubmitParkingRecordData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitParkingRecord({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getParkingRecordResponseQueryKey = (options: Options<GetParkingRecordResponseData>) =>
  createQueryKey('getParkingRecordResponse', options)

/**
 * Get Parking Record Response
 */
export const getParkingRecordResponseOptions = (options: Options<GetParkingRecordResponseData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getParkingRecordResponse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getParkingRecordResponseQueryKey(options),
  })
}

export const submitRouteRecordQueryKey = (options: Options<SubmitRouteRecordData>) =>
  createQueryKey('submitRouteRecord', options)

/**
 * Submit Route Record
 */
export const submitRouteRecordOptions = (options: Options<SubmitRouteRecordData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitRouteRecord({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitRouteRecordQueryKey(options),
  })
}

/**
 * Submit Route Record
 */
export const submitRouteRecordMutation = (
  options?: Partial<Options<SubmitRouteRecordData>>
): UseMutationOptions<SubmitRouteRecordResponse, SubmitRouteRecordError, Options<SubmitRouteRecordData>> => {
  const mutationOptions: UseMutationOptions<
    SubmitRouteRecordResponse,
    SubmitRouteRecordError,
    Options<SubmitRouteRecordData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitRouteRecord({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const submitEvidencePackageQueryKey = (options: Options<SubmitEvidencePackageData>) =>
  createQueryKey('submitEvidencePackage', options)

/**
 * Submit Evidence Package
 */
export const submitEvidencePackageOptions = (options: Options<SubmitEvidencePackageData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitEvidencePackage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitEvidencePackageQueryKey(options),
  })
}

/**
 * Submit Evidence Package
 */
export const submitEvidencePackageMutation = (
  options?: Partial<Options<SubmitEvidencePackageData>>
): UseMutationOptions<
  SubmitEvidencePackageResponse,
  SubmitEvidencePackageError,
  Options<SubmitEvidencePackageData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitEvidencePackageResponse,
    SubmitEvidencePackageError,
    Options<SubmitEvidencePackageData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitEvidencePackage({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const shouldSubmitEvidencePackageQueryKey = (options?: Options<ShouldSubmitEvidencePackageData>) =>
  createQueryKey('shouldSubmitEvidencePackage', options)

/**
 * Should Submit Evidence Package
 * Check whether an evidence package should be submitted.
 */
export const shouldSubmitEvidencePackageOptions = (options?: Options<ShouldSubmitEvidencePackageData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await shouldSubmitEvidencePackage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: shouldSubmitEvidencePackageQueryKey(options),
  })
}

export const submitSkippedRouteSegmentRecordQueryKey = (options: Options<SubmitSkippedRouteSegmentRecordData>) =>
  createQueryKey('submitSkippedRouteSegmentRecord', options)

/**
 * Submit Skipped Route Segment Record
 */
export const submitSkippedRouteSegmentRecordOptions = (options: Options<SubmitSkippedRouteSegmentRecordData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitSkippedRouteSegmentRecord({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitSkippedRouteSegmentRecordQueryKey(options),
  })
}

/**
 * Submit Skipped Route Segment Record
 */
export const submitSkippedRouteSegmentRecordMutation = (
  options?: Partial<Options<SubmitSkippedRouteSegmentRecordData>>
): UseMutationOptions<
  SubmitSkippedRouteSegmentRecordResponse,
  SubmitSkippedRouteSegmentRecordError,
  Options<SubmitSkippedRouteSegmentRecordData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitSkippedRouteSegmentRecordResponse,
    SubmitSkippedRouteSegmentRecordError,
    Options<SubmitSkippedRouteSegmentRecordData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitSkippedRouteSegmentRecord({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const submitSignPostRecordQueryKey = (options: Options<SubmitSignPostRecordData>) =>
  createQueryKey('submitSignPostRecord', options)

/**
 * Submit Sign Post Record
 */
export const submitSignPostRecordOptions = (options: Options<SubmitSignPostRecordData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitSignPostRecord({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitSignPostRecordQueryKey(options),
  })
}

/**
 * Submit Sign Post Record
 */
export const submitSignPostRecordMutation = (
  options?: Partial<Options<SubmitSignPostRecordData>>
): UseMutationOptions<SubmitSignPostRecordResponse, SubmitSignPostRecordError, Options<SubmitSignPostRecordData>> => {
  const mutationOptions: UseMutationOptions<
    SubmitSignPostRecordResponse,
    SubmitSignPostRecordError,
    Options<SubmitSignPostRecordData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitSignPostRecord({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const submitUnexpectedEventQueryKey = (options: Options<SubmitUnexpectedEventData>) =>
  createQueryKey('submitUnexpectedEvent', options)

/**
 * Submit Unexpected Event
 */
export const submitUnexpectedEventOptions = (options: Options<SubmitUnexpectedEventData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitUnexpectedEvent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitUnexpectedEventQueryKey(options),
  })
}

/**
 * Submit Unexpected Event
 */
export const submitUnexpectedEventMutation = (
  options?: Partial<Options<SubmitUnexpectedEventData>>
): UseMutationOptions<
  SubmitUnexpectedEventResponse,
  SubmitUnexpectedEventError,
  Options<SubmitUnexpectedEventData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitUnexpectedEventResponse,
    SubmitUnexpectedEventError,
    Options<SubmitUnexpectedEventData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitUnexpectedEvent({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const submitUnexpectedEventPackageQueryKey = (options: Options<SubmitUnexpectedEventPackageData>) =>
  createQueryKey('submitUnexpectedEventPackage', options)

/**
 * Submit Unexpected Event Package
 */
export const submitUnexpectedEventPackageOptions = (options: Options<SubmitUnexpectedEventPackageData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitUnexpectedEventPackage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitUnexpectedEventPackageQueryKey(options),
  })
}

/**
 * Submit Unexpected Event Package
 */
export const submitUnexpectedEventPackageMutation = (
  options?: Partial<Options<SubmitUnexpectedEventPackageData>>
): UseMutationOptions<
  SubmitUnexpectedEventPackageResponse,
  SubmitUnexpectedEventPackageError,
  Options<SubmitUnexpectedEventPackageData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitUnexpectedEventPackageResponse,
    SubmitUnexpectedEventPackageError,
    Options<SubmitUnexpectedEventPackageData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitUnexpectedEventPackage({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const shouldSubmitUnexpectedEventPackageQueryKey = (options?: Options<ShouldSubmitUnexpectedEventPackageData>) =>
  createQueryKey('shouldSubmitUnexpectedEventPackage', options)

/**
 * Should Submit Unexpected Event Package
 */
export const shouldSubmitUnexpectedEventPackageOptions = (
  options?: Options<ShouldSubmitUnexpectedEventPackageData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await shouldSubmitUnexpectedEventPackage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: shouldSubmitUnexpectedEventPackageQueryKey(options),
  })
}

export const submitVehiclePositionQueryKey = (options: Options<SubmitVehiclePositionData>) =>
  createQueryKey('submitVehiclePosition', options)

/**
 * Submit Vehicle Position
 * Submit a vehicle position data
 *
 * Body:
 * - position_data (VehiclePositionBatch): Vehicle position data
 *
 * Examples:
 * - position_data: {
 * "values": [
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0],
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0],
 * ...
 * ]
 * }
 * - values item:
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0]
 * consists of:
 * - timestamp: Unix timestamp
 * - latitude: Latitude
 * - longitude: Longitude
 * - cno: CNO mean
 * - confidence: Confidence
 * - lon_std_dev: Longitude standard deviation [m]
 * - lat_std_dev: Latitude standard deviation [m]
 * - azimuth: Azimuth [deg]
 */
export const submitVehiclePositionOptions = (options: Options<SubmitVehiclePositionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitVehiclePosition({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: submitVehiclePositionQueryKey(options),
  })
}

/**
 * Submit Vehicle Position
 * Submit a vehicle position data
 *
 * Body:
 * - position_data (VehiclePositionBatch): Vehicle position data
 *
 * Examples:
 * - position_data: {
 * "values": [
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0],
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0],
 * ...
 * ]
 * }
 * - values item:
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0]
 * consists of:
 * - timestamp: Unix timestamp
 * - latitude: Latitude
 * - longitude: Longitude
 * - cno: CNO mean
 * - confidence: Confidence
 * - lon_std_dev: Longitude standard deviation [m]
 * - lat_std_dev: Latitude standard deviation [m]
 * - azimuth: Azimuth [deg]
 */
export const submitVehiclePositionMutation = (
  options?: Partial<Options<SubmitVehiclePositionData>>
): UseMutationOptions<
  SubmitVehiclePositionResponse,
  SubmitVehiclePositionError,
  Options<SubmitVehiclePositionData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitVehiclePositionResponse,
    SubmitVehiclePositionError,
    Options<SubmitVehiclePositionData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitVehiclePosition({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDriversAndScheduledShiftsQueryKey = (options?: Options<GetDriversAndScheduledShiftsData>) =>
  createQueryKey('getDriversAndScheduledShifts', options)

/**
 * Get Drivers And Scheduled Shifts
 */
export const getDriversAndScheduledShiftsOptions = (options?: Options<GetDriversAndScheduledShiftsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriversAndScheduledShifts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDriversAndScheduledShiftsQueryKey(options),
  })
}

export const getActiveWorkPeriodQueryKey = (options?: Options<GetActiveWorkPeriodData>) =>
  createQueryKey('getActiveWorkPeriod', options)

/**
 * Get Active Work Period
 */
export const getActiveWorkPeriodOptions = (options?: Options<GetActiveWorkPeriodData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActiveWorkPeriod({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getActiveWorkPeriodQueryKey(options),
  })
}

export const driverSignInQueryKey = (options: Options<DriverSignInData>) => createQueryKey('driverSignIn', options)

/**
 * Driver Sign In
 * Start a driver work period.
 */
export const driverSignInOptions = (options: Options<DriverSignInData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await driverSignIn({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: driverSignInQueryKey(options),
  })
}

/**
 * Driver Sign In
 * Start a driver work period.
 */
export const driverSignInMutation = (
  options?: Partial<Options<DriverSignInData>>
): UseMutationOptions<DriverSignInResponse, DriverSignInError, Options<DriverSignInData>> => {
  const mutationOptions: UseMutationOptions<DriverSignInResponse, DriverSignInError, Options<DriverSignInData>> = {
    mutationFn: async localOptions => {
      const { data } = await driverSignIn({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const driverSignOutQueryKey = (options?: Options<DriverSignOutData>) => createQueryKey('driverSignOut', options)

/**
 * Driver Sign Out
 * Finish the current driver work period.
 */
export const driverSignOutOptions = (options?: Options<DriverSignOutData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await driverSignOut({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: driverSignOutQueryKey(options),
  })
}

/**
 * Driver Sign Out
 * Finish the current driver work period.
 */
export const driverSignOutMutation = (
  options?: Partial<Options<DriverSignOutData>>
): UseMutationOptions<DriverSignOutResponse, DriverSignOutError, Options<DriverSignOutData>> => {
  const mutationOptions: UseMutationOptions<DriverSignOutResponse, DriverSignOutError, Options<DriverSignOutData>> = {
    mutationFn: async localOptions => {
      const { data } = await driverSignOut({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const reportDriveStartedQueryKey = (options: Options<ReportDriveStartedData>) =>
  createQueryKey('reportDriveStarted', options)

/**
 * Report Drive Started
 * Report that the car just started the drive.
 */
export const reportDriveStartedOptions = (options: Options<ReportDriveStartedData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportDriveStarted({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reportDriveStartedQueryKey(options),
  })
}

/**
 * Report Drive Started
 * Report that the car just started the drive.
 */
export const reportDriveStartedMutation = (
  options?: Partial<Options<ReportDriveStartedData>>
): UseMutationOptions<ReportDriveStartedResponse, ReportDriveStartedError, Options<ReportDriveStartedData>> => {
  const mutationOptions: UseMutationOptions<
    ReportDriveStartedResponse,
    ReportDriveStartedError,
    Options<ReportDriveStartedData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await reportDriveStarted({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const reportDriveFinishedQueryKey = (options: Options<ReportDriveFinishedData>) =>
  createQueryKey('reportDriveFinished', options)

/**
 * Report Drive Finished
 * Report that the car just finished the drive.
 */
export const reportDriveFinishedOptions = (options: Options<ReportDriveFinishedData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportDriveFinished({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reportDriveFinishedQueryKey(options),
  })
}

/**
 * Report Drive Finished
 * Report that the car just finished the drive.
 */
export const reportDriveFinishedMutation = (
  options?: Partial<Options<ReportDriveFinishedData>>
): UseMutationOptions<ReportDriveFinishedResponse, ReportDriveFinishedError, Options<ReportDriveFinishedData>> => {
  const mutationOptions: UseMutationOptions<
    ReportDriveFinishedResponse,
    ReportDriveFinishedError,
    Options<ReportDriveFinishedData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await reportDriveFinished({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getFinishedDriveStatisticsQueryKey = (options: Options<GetFinishedDriveStatisticsData>) =>
  createQueryKey('getFinishedDriveStatistics', options)

/**
 * Get Finished Drive Statistics
 * Fetch statistics for a finished drive.
 */
export const getFinishedDriveStatisticsOptions = (options: Options<GetFinishedDriveStatisticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFinishedDriveStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getFinishedDriveStatisticsQueryKey(options),
  })
}

export const scheduleFreerideQueryKey = (options?: Options<ScheduleFreerideData>) =>
  createQueryKey('scheduleFreeride', options)

/**
 * Schedule Freeride
 */
export const scheduleFreerideOptions = (options?: Options<ScheduleFreerideData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await scheduleFreeride({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: scheduleFreerideQueryKey(options),
  })
}

/**
 * Schedule Freeride
 */
export const scheduleFreerideMutation = (
  options?: Partial<Options<ScheduleFreerideData>>
): UseMutationOptions<ScheduleFreerideResponse, ScheduleFreerideError, Options<ScheduleFreerideData>> => {
  const mutationOptions: UseMutationOptions<
    ScheduleFreerideResponse,
    ScheduleFreerideError,
    Options<ScheduleFreerideData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await scheduleFreeride({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postComputeRoutesQueryKey = (options: Options<PostComputeRoutesData>) =>
  createQueryKey('postComputeRoutes', options)

/**
 * Post Compute Routes
 */
export const postComputeRoutesOptions = (options: Options<PostComputeRoutesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postComputeRoutes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postComputeRoutesQueryKey(options),
  })
}

/**
 * Post Compute Routes
 */
export const postComputeRoutesMutation = (
  options?: Partial<Options<PostComputeRoutesData>>
): UseMutationOptions<PostComputeRoutesResponse, PostComputeRoutesError, Options<PostComputeRoutesData>> => {
  const mutationOptions: UseMutationOptions<
    PostComputeRoutesResponse,
    PostComputeRoutesError,
    Options<PostComputeRoutesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postComputeRoutes({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getEmptyTechnicalSegmentsQueryKey = (options?: Options<GetEmptyTechnicalSegmentsData>) =>
  createQueryKey('getEmptyTechnicalSegments', options)

/**
 * Get Empty Technical Segments
 */
export const getEmptyTechnicalSegmentsOptions = (options?: Options<GetEmptyTechnicalSegmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEmptyTechnicalSegments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getEmptyTechnicalSegmentsQueryKey(options),
  })
}

/**
 * Submit Empty Technical Segment Evidence
 */
export const submitEmptyTechnicalSegmentEvidenceMutation = (
  options?: Partial<Options<SubmitEmptyTechnicalSegmentEvidenceData>>
): UseMutationOptions<
  SubmitEmptyTechnicalSegmentEvidenceResponse,
  SubmitEmptyTechnicalSegmentEvidenceError,
  Options<SubmitEmptyTechnicalSegmentEvidenceData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitEmptyTechnicalSegmentEvidenceResponse,
    SubmitEmptyTechnicalSegmentEvidenceError,
    Options<SubmitEmptyTechnicalSegmentEvidenceData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await submitEmptyTechnicalSegmentEvidence({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Empty Technical Segments
 */
export const deleteEmptyTechnicalSegmentsMutation = (
  options?: Partial<Options<DeleteEmptyTechnicalSegmentsData>>
): UseMutationOptions<
  DeleteEmptyTechnicalSegmentsResponse,
  DeleteEmptyTechnicalSegmentsError,
  Options<DeleteEmptyTechnicalSegmentsData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteEmptyTechnicalSegmentsResponse,
    DeleteEmptyTechnicalSegmentsError,
    Options<DeleteEmptyTechnicalSegmentsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteEmptyTechnicalSegments({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAllPlanningAreasQueryKey = (options?: Options<GetAllPlanningAreasData>) =>
  createQueryKey('getAllPlanningAreas', options)

/**
 * Get All Planning Areas
 */
export const getAllPlanningAreasOptions = (options?: Options<GetAllPlanningAreasData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllPlanningAreas({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllPlanningAreasQueryKey(options),
  })
}

/**
 * Delete Planning Area
 * Permanently delete a planning area. This will fail if routes still exist in that area.
 */
export const deletePlanningAreaMutation = (
  options?: Partial<Options<DeletePlanningAreaData>>
): UseMutationOptions<DeletePlanningAreaResponse, DeletePlanningAreaError, Options<DeletePlanningAreaData>> => {
  const mutationOptions: UseMutationOptions<
    DeletePlanningAreaResponse,
    DeletePlanningAreaError,
    Options<DeletePlanningAreaData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deletePlanningArea({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getPlanningAreaQueryKey = (options: Options<GetPlanningAreaData>) =>
  createQueryKey('getPlanningArea', options)

/**
 * Get Planning Area
 */
export const getPlanningAreaOptions = (options: Options<GetPlanningAreaData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlanningArea({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPlanningAreaQueryKey(options),
  })
}

/**
 * Update Planning Area
 */
export const updatePlanningAreaMutation = (
  options?: Partial<Options<UpdatePlanningAreaData>>
): UseMutationOptions<UpdatePlanningAreaResponse, UpdatePlanningAreaError, Options<UpdatePlanningAreaData>> => {
  const mutationOptions: UseMutationOptions<
    UpdatePlanningAreaResponse,
    UpdatePlanningAreaError,
    Options<UpdatePlanningAreaData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updatePlanningArea({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Create District
 */
export const createDistrictMutation = (
  options?: Partial<Options<CreateDistrictData>>
): UseMutationOptions<CreateDistrictResponse, CreateDistrictError, Options<CreateDistrictData>> => {
  const mutationOptions: UseMutationOptions<
    CreateDistrictResponse,
    CreateDistrictError,
    Options<CreateDistrictData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await createDistrict({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getPlanningDataQueryKey = (options: Options<GetPlanningDataData>) =>
  createQueryKey('getPlanningData', options)

/**
 * Get Planning Data
 */
export const getPlanningDataOptions = (options: Options<GetPlanningDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlanningData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPlanningDataQueryKey(options),
  })
}

export const getDistrictMapQueryKey = (options?: Options<GetDistrictMapData>) =>
  createQueryKey('getDistrictMap', options)

/**
 * Get District Map
 */
export const getDistrictMapOptions = (options?: Options<GetDistrictMapData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDistrictMap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDistrictMapQueryKey(options),
  })
}

export const getAllActiveRoutesQueryKey = (options?: Options<GetAllActiveRoutesData>) =>
  createQueryKey('getAllActiveRoutes', options)

/**
 * Get All Active Routes
 */
export const getAllActiveRoutesOptions = (options?: Options<GetAllActiveRoutesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllActiveRoutes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllActiveRoutesQueryKey(options),
  })
}

export const getRouteProblemsSummaryQueryKey = (options?: Options<GetRouteProblemsSummaryData>) =>
  createQueryKey('getRouteProblemsSummary', options)

/**
 * Get Route Problems Summary
 */
export const getRouteProblemsSummaryOptions = (options?: Options<GetRouteProblemsSummaryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRouteProblemsSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRouteProblemsSummaryQueryKey(options),
  })
}

export const getRoutesInAreaQueryKey = (options: Options<GetRoutesInAreaData>) =>
  createQueryKey('getRoutesInArea', options)

/**
 * Get Routes In Area
 */
export const getRoutesInAreaOptions = (options: Options<GetRoutesInAreaData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRoutesInArea({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRoutesInAreaQueryKey(options),
  })
}

export const getRouteTsCoverageAllQueryKey = (options?: Options<GetRouteTsCoverageAllData>) =>
  createQueryKey('getRouteTsCoverageAll', options)

/**
 * Get Route Ts Coverage All
 * Evaluate route coverage for all planning areas against active routes and TS/RZ/SP.
 *
 * Returns a lightweight summary per planning area suitable for dashboards. The
 * detailed per-area breakdown remains available at `/route-ts-coverage/{planning_area_id}`.
 * When ``only_with_active_routes`` is true (default), only planning areas that have at
 * least one active route are included.
 */
export const getRouteTsCoverageAllOptions = (options?: Options<GetRouteTsCoverageAllData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRouteTsCoverageAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRouteTsCoverageAllQueryKey(options),
  })
}

export const getRouteTsCoverageQueryKey = (options: Options<GetRouteTsCoverageData>) =>
  createQueryKey('getRouteTsCoverage', options)

/**
 * Get Route Ts Coverage
 * Check which technical segments in a planning area are covered by active routes.
 */
export const getRouteTsCoverageOptions = (options: Options<GetRouteTsCoverageData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRouteTsCoverage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRouteTsCoverageQueryKey(options),
  })
}

export const checkRouteWithGoogleMapsQueryKey = (options: Options<CheckRouteWithGoogleMapsData>) =>
  createQueryKey('checkRouteWithGoogleMaps', options)

/**
 * Check Route With Google Maps
 */
export const checkRouteWithGoogleMapsOptions = (options: Options<CheckRouteWithGoogleMapsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await checkRouteWithGoogleMaps({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: checkRouteWithGoogleMapsQueryKey(options),
  })
}

export const validateStreetSegmentGeometryQueryKey = (options?: Options<ValidateStreetSegmentGeometryData>) =>
  createQueryKey('validateStreetSegmentGeometry', options)

/**
 * Validate Street Segment Geometry
 */
export const validateStreetSegmentGeometryOptions = (options?: Options<ValidateStreetSegmentGeometryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await validateStreetSegmentGeometry({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: validateStreetSegmentGeometryQueryKey(options),
  })
}

/**
 * Delete Route
 * Permanently delete a route. This will fail if drive records for that route still exist.
 */
export const deleteRouteMutation = (
  options?: Partial<Options<DeleteRouteData>>
): UseMutationOptions<DeleteRouteResponse, DeleteRouteError, Options<DeleteRouteData>> => {
  const mutationOptions: UseMutationOptions<DeleteRouteResponse, DeleteRouteError, Options<DeleteRouteData>> = {
    mutationFn: async localOptions => {
      const { data } = await deleteRoute({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getRouteQueryKey = (options: Options<GetRouteData>) => createQueryKey('getRoute', options)

/**
 * Get Route
 */
export const getRouteOptions = (options: Options<GetRouteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRoute({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRouteQueryKey(options),
  })
}

export const createRouteQueryKey = (options: Options<CreateRouteData>) => createQueryKey('createRoute', options)

/**
 * Create Route
 */
export const createRouteOptions = (options: Options<CreateRouteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createRoute({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createRouteQueryKey(options),
  })
}

/**
 * Create Route
 */
export const createRouteMutation = (
  options?: Partial<Options<CreateRouteData>>
): UseMutationOptions<CreateRouteResponse, CreateRouteError, Options<CreateRouteData>> => {
  const mutationOptions: UseMutationOptions<CreateRouteResponse, CreateRouteError, Options<CreateRouteData>> = {
    mutationFn: async localOptions => {
      const { data } = await createRoute({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Route Drives
 * Permanently delete all drive records for given route. This may lead to a loss of valuable billing data.
 */
export const deleteRouteDrivesMutation = (
  options?: Partial<Options<DeleteRouteDrivesData>>
): UseMutationOptions<DeleteRouteDrivesResponse, DeleteRouteDrivesError, Options<DeleteRouteDrivesData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteRouteDrivesResponse,
    DeleteRouteDrivesError,
    Options<DeleteRouteDrivesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteRouteDrives({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateRouteFragmentsQueryKey = (options: Options<UpdateRouteFragmentsData>) =>
  createQueryKey('updateRouteFragments', options)

/**
 * Update Route Fragments
 */
export const updateRouteFragmentsOptions = (options: Options<UpdateRouteFragmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateRouteFragments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateRouteFragmentsQueryKey(options),
  })
}

/**
 * Update Route Fragments
 */
export const updateRouteFragmentsMutation = (
  options?: Partial<Options<UpdateRouteFragmentsData>>
): UseMutationOptions<UpdateRouteFragmentsResponse, UpdateRouteFragmentsError, Options<UpdateRouteFragmentsData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateRouteFragmentsResponse,
    UpdateRouteFragmentsError,
    Options<UpdateRouteFragmentsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateRouteFragments({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const autogenerateRouteFragmentsQueryKey = (options: Options<AutogenerateRouteFragmentsData>) =>
  createQueryKey('autogenerateRouteFragments', options)

/**
 * Autogenerate Route Fragments
 */
export const autogenerateRouteFragmentsOptions = (options: Options<AutogenerateRouteFragmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await autogenerateRouteFragments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: autogenerateRouteFragmentsQueryKey(options),
  })
}

/**
 * Autogenerate Route Fragments
 */
export const autogenerateRouteFragmentsMutation = (
  options?: Partial<Options<AutogenerateRouteFragmentsData>>
): UseMutationOptions<
  AutogenerateRouteFragmentsResponse,
  AutogenerateRouteFragmentsError,
  Options<AutogenerateRouteFragmentsData>
> => {
  const mutationOptions: UseMutationOptions<
    AutogenerateRouteFragmentsResponse,
    AutogenerateRouteFragmentsError,
    Options<AutogenerateRouteFragmentsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await autogenerateRouteFragments({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getStreetSegmentsInPolygonQueryKey = (options: Options<GetStreetSegmentsInPolygonData>) =>
  createQueryKey('getStreetSegmentsInPolygon', options)

/**
 * Get Street Segments In Polygon
 */
export const getStreetSegmentsInPolygonOptions = (options: Options<GetStreetSegmentsInPolygonData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStreetSegmentsInPolygon({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getStreetSegmentsInPolygonQueryKey(options),
  })
}

/**
 * Get Street Segments In Polygon
 */
export const getStreetSegmentsInPolygonMutation = (
  options?: Partial<Options<GetStreetSegmentsInPolygonData>>
): UseMutationOptions<
  GetStreetSegmentsInPolygonResponse,
  GetStreetSegmentsInPolygonError,
  Options<GetStreetSegmentsInPolygonData>
> => {
  const mutationOptions: UseMutationOptions<
    GetStreetSegmentsInPolygonResponse,
    GetStreetSegmentsInPolygonError,
    Options<GetStreetSegmentsInPolygonData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await getStreetSegmentsInPolygon({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDistrictPlanningDataQueryKey = (options: Options<GetDistrictPlanningDataData>) =>
  createQueryKey('getDistrictPlanningData', options)

/**
 * Get District Planning Data
 */
export const getDistrictPlanningDataOptions = (options: Options<GetDistrictPlanningDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDistrictPlanningData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDistrictPlanningDataQueryKey(options),
  })
}

/**
 * Get District Planning Data
 */
export const getDistrictPlanningDataMutation = (
  options?: Partial<Options<GetDistrictPlanningDataData>>
): UseMutationOptions<
  GetDistrictPlanningDataResponse,
  GetDistrictPlanningDataError,
  Options<GetDistrictPlanningDataData>
> => {
  const mutationOptions: UseMutationOptions<
    GetDistrictPlanningDataResponse,
    GetDistrictPlanningDataError,
    Options<GetDistrictPlanningDataData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await getDistrictPlanningData({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAllPlanningDataQueryKey = (options?: Options<GetAllPlanningDataData>) =>
  createQueryKey('getAllPlanningData', options)

/**
 * Get All Planning Data
 */
export const getAllPlanningDataOptions = (options?: Options<GetAllPlanningDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllPlanningData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllPlanningDataQueryKey(options),
  })
}

/**
 * Get All Planning Data
 */
export const getAllPlanningDataMutation = (
  options?: Partial<Options<GetAllPlanningDataData>>
): UseMutationOptions<GetAllPlanningDataResponse, GetAllPlanningDataError, Options<GetAllPlanningDataData>> => {
  const mutationOptions: UseMutationOptions<
    GetAllPlanningDataResponse,
    GetAllPlanningDataError,
    Options<GetAllPlanningDataData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await getAllPlanningData({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postPlanningDataInPolygonQueryKey = (options: Options<PostPlanningDataInPolygonData>) =>
  createQueryKey('postPlanningDataInPolygon', options)

/**
 * Post Planning Data In Polygon
 */
export const postPlanningDataInPolygonOptions = (options: Options<PostPlanningDataInPolygonData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postPlanningDataInPolygon({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postPlanningDataInPolygonQueryKey(options),
  })
}

/**
 * Post Planning Data In Polygon
 */
export const postPlanningDataInPolygonMutation = (
  options?: Partial<Options<PostPlanningDataInPolygonData>>
): UseMutationOptions<
  PostPlanningDataInPolygonResponse,
  PostPlanningDataInPolygonError,
  Options<PostPlanningDataInPolygonData>
> => {
  const mutationOptions: UseMutationOptions<
    PostPlanningDataInPolygonResponse,
    PostPlanningDataInPolygonError,
    Options<PostPlanningDataInPolygonData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postPlanningDataInPolygon({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getOverrideListQueryKey = (options: Options<GetOverrideListData>) =>
  createQueryKey('getOverrideList', options)

/**
 * Get Override List
 */
export const getOverrideListOptions = (options: Options<GetOverrideListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOverrideList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOverrideListQueryKey(options),
  })
}

export const getSnapshotListQueryKey = (options?: Options<GetSnapshotListData>) =>
  createQueryKey('getSnapshotList', options)

/**
 * Get Snapshot List
 */
export const getSnapshotListOptions = (options?: Options<GetSnapshotListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSnapshotList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSnapshotListQueryKey(options),
  })
}

export const getSnapshotListWithOverridesQueryKey = (options?: Options<GetSnapshotListWithOverridesData>) =>
  createQueryKey('getSnapshotListWithOverrides', options)

/**
 * Get Snapshot List With Overrides
 */
export const getSnapshotListWithOverridesOptions = (options?: Options<GetSnapshotListWithOverridesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSnapshotListWithOverrides({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSnapshotListWithOverridesQueryKey(options),
  })
}

export const compareTwoSnapshotsQueryKey = (options: Options<CompareTwoSnapshotsData>) =>
  createQueryKey('compareTwoSnapshots', options)

/**
 * Compare Two Snapshots
 */
export const compareTwoSnapshotsOptions = (options: Options<CompareTwoSnapshotsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await compareTwoSnapshots({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: compareTwoSnapshotsQueryKey(options),
  })
}

export const getStreetSegmentsQueryKey = (options?: Options<GetStreetSegmentsData>) =>
  createQueryKey('getStreetSegments', options)

/**
 * Get Street Segments
 */
export const getStreetSegmentsOptions = (options?: Options<GetStreetSegmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStreetSegments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getStreetSegmentsQueryKey(options),
  })
}

export const getTskSegmentsQueryKey = (options: Options<GetTskSegmentsData>) =>
  createQueryKey('getTskSegments', options)

/**
 * Get Tsk Segments
 */
export const getTskSegmentsOptions = (options: Options<GetTskSegmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTskSegments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTskSegmentsQueryKey(options),
  })
}

export const getRequirementsQueryKey = (options: Options<GetRequirementsData>) =>
  createQueryKey('getRequirements', options)

/**
 * Get Requirements
 */
export const getRequirementsOptions = (options: Options<GetRequirementsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRequirements({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRequirementsQueryKey(options),
  })
}

export const getRequirementsDocuQueryKey = (options: Options<GetRequirementsDocuData>) =>
  createQueryKey('getRequirementsDocu', options)

/**
 * Get Requirements Docu
 */
export const getRequirementsDocuOptions = (options: Options<GetRequirementsDocuData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRequirementsDocu({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRequirementsDocuQueryKey(options),
  })
}

export const getControlDataSchemasQueryKey = (options?: Options<GetControlDataSchemasData>) =>
  createQueryKey('getControlDataSchemas', options)

/**
 * Get Control Data Schemas
 */
export const getControlDataSchemasOptions = (options?: Options<GetControlDataSchemasData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControlDataSchemas({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getControlDataSchemasQueryKey(options),
  })
}

export const createMapSnapshotQueryKey = (options: Options<CreateMapSnapshotData>) =>
  createQueryKey('createMapSnapshot', options)

/**
 * Create Map Snapshot
 */
export const createMapSnapshotOptions = (options: Options<CreateMapSnapshotData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createMapSnapshot({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createMapSnapshotQueryKey(options),
  })
}

/**
 * Create Map Snapshot
 */
export const createMapSnapshotMutation = (
  options?: Partial<Options<CreateMapSnapshotData>>
): UseMutationOptions<CreateMapSnapshotResponse, CreateMapSnapshotError, Options<CreateMapSnapshotData>> => {
  const mutationOptions: UseMutationOptions<
    CreateMapSnapshotResponse,
    CreateMapSnapshotError,
    Options<CreateMapSnapshotData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await createMapSnapshot({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getCurrentSnapshotQueryKey = (options?: Options<GetCurrentSnapshotData>) =>
  createQueryKey('getCurrentSnapshot', options)

/**
 * Get Current Snapshot
 */
export const getCurrentSnapshotOptions = (options?: Options<GetCurrentSnapshotData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentSnapshot({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getCurrentSnapshotQueryKey(options),
  })
}

export const getControlDataDataVersionQueryKey = (options?: Options<GetControlDataDataVersionData>) =>
  createQueryKey('getControlDataDataVersion', options)

/**
 * Get Control Data Data Version
 */
export const getControlDataDataVersionOptions = (options?: Options<GetControlDataDataVersionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControlDataDataVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getControlDataDataVersionQueryKey(options),
  })
}

export const syncMapsQueryKey = (options: Options<SyncMapsData>) => createQueryKey('syncMaps', options)

/**
 * Sync Maps
 */
export const syncMapsOptions = (options: Options<SyncMapsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await syncMaps({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: syncMapsQueryKey(options),
  })
}

/**
 * Sync Maps
 */
export const syncMapsMutation = (
  options?: Partial<Options<SyncMapsData>>
): UseMutationOptions<SyncMapsResponse, SyncMapsError, Options<SyncMapsData>> => {
  const mutationOptions: UseMutationOptions<SyncMapsResponse, SyncMapsError, Options<SyncMapsData>> = {
    mutationFn: async localOptions => {
      const { data } = await syncMaps({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteSnapshotQueryKey = (options: Options<DeleteSnapshotData>) =>
  createQueryKey('deleteSnapshot', options)

/**
 * Delete Snapshot
 */
export const deleteSnapshotOptions = (options: Options<DeleteSnapshotData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deleteSnapshot({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: deleteSnapshotQueryKey(options),
  })
}

/**
 * Delete Snapshot
 */
export const deleteSnapshotMutation = (
  options?: Partial<Options<DeleteSnapshotData>>
): UseMutationOptions<DeleteSnapshotResponse, DeleteSnapshotError, Options<DeleteSnapshotData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteSnapshotResponse,
    DeleteSnapshotError,
    Options<DeleteSnapshotData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteSnapshot({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const syncOpenstreetmapsQueryKey = (options: Options<SyncOpenstreetmapsData>) =>
  createQueryKey('syncOpenstreetmaps', options)

/**
 * Sync Openstreetmaps
 */
export const syncOpenstreetmapsOptions = (options: Options<SyncOpenstreetmapsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await syncOpenstreetmaps({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: syncOpenstreetmapsQueryKey(options),
  })
}

/**
 * Sync Openstreetmaps
 */
export const syncOpenstreetmapsMutation = (
  options?: Partial<Options<SyncOpenstreetmapsData>>
): UseMutationOptions<SyncOpenstreetmapsResponse, SyncOpenstreetmapsError, Options<SyncOpenstreetmapsData>> => {
  const mutationOptions: UseMutationOptions<
    SyncOpenstreetmapsResponse,
    SyncOpenstreetmapsError,
    Options<SyncOpenstreetmapsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await syncOpenstreetmaps({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getStreetSegmentQueryKey = (options: Options<GetStreetSegmentData>) =>
  createQueryKey('getStreetSegment', options)

/**
 * Get Street Segment
 */
export const getStreetSegmentOptions = (options: Options<GetStreetSegmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStreetSegment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getStreetSegmentQueryKey(options),
  })
}

export const getTechnicalSegmentQueryKey = (options: Options<GetTechnicalSegmentData>) =>
  createQueryKey('getTechnicalSegment', options)

/**
 * Get Technical Segment
 */
export const getTechnicalSegmentOptions = (options: Options<GetTechnicalSegmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTechnicalSegment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTechnicalSegmentQueryKey(options),
  })
}

export const getRegulatedZoneQueryKey = (options: Options<GetRegulatedZoneData>) =>
  createQueryKey('getRegulatedZone', options)

/**
 * Get Regulated Zone
 */
export const getRegulatedZoneOptions = (options: Options<GetRegulatedZoneData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRegulatedZone({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRegulatedZoneQueryKey(options),
  })
}

export const getSignPostQueryKey = (options: Options<GetSignPostData>) => createQueryKey('getSignPost', options)

/**
 * Get Sign Post
 */
export const getSignPostOptions = (options: Options<GetSignPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSignPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSignPostQueryKey(options),
  })
}

export const getPlanningAreaSplitsQueryKey = (options: Options<GetPlanningAreaSplitsData>) =>
  createQueryKey('getPlanningAreaSplits', options)

/**
 * Get Planning Area Splits
 */
export const getPlanningAreaSplitsOptions = (options: Options<GetPlanningAreaSplitsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlanningAreaSplits({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPlanningAreaSplitsQueryKey(options),
  })
}

/**
 * Save Planning Area Splits
 */
export const savePlanningAreaSplitsMutation = (
  options?: Partial<Options<SavePlanningAreaSplitsData>>
): UseMutationOptions<
  SavePlanningAreaSplitsResponse,
  SavePlanningAreaSplitsError,
  Options<SavePlanningAreaSplitsData>
> => {
  const mutationOptions: UseMutationOptions<
    SavePlanningAreaSplitsResponse,
    SavePlanningAreaSplitsError,
    Options<SavePlanningAreaSplitsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await savePlanningAreaSplits({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSplitsDistrictPlanningDataQueryKey = (options: Options<GetSplitsDistrictPlanningDataData>) =>
  createQueryKey('getSplitsDistrictPlanningData', options)

/**
 * Get Splits District Planning Data
 */
export const getSplitsDistrictPlanningDataOptions = (options: Options<GetSplitsDistrictPlanningDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSplitsDistrictPlanningData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSplitsDistrictPlanningDataQueryKey(options),
  })
}

/**
 * Get Splits District Planning Data
 */
export const getSplitsDistrictPlanningDataMutation = (
  options?: Partial<Options<GetSplitsDistrictPlanningDataData>>
): UseMutationOptions<
  GetSplitsDistrictPlanningDataResponse,
  GetSplitsDistrictPlanningDataError,
  Options<GetSplitsDistrictPlanningDataData>
> => {
  const mutationOptions: UseMutationOptions<
    GetSplitsDistrictPlanningDataResponse,
    GetSplitsDistrictPlanningDataError,
    Options<GetSplitsDistrictPlanningDataData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await getSplitsDistrictPlanningData({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const computeDistrictSplitsQueryKey = (options: Options<ComputeDistrictSplitsData>) =>
  createQueryKey('computeDistrictSplits', options)

/**
 * Compute District Splits
 */
export const computeDistrictSplitsOptions = (options: Options<ComputeDistrictSplitsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await computeDistrictSplits({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: computeDistrictSplitsQueryKey(options),
  })
}

/**
 * Compute District Splits
 */
export const computeDistrictSplitsMutation = (
  options?: Partial<Options<ComputeDistrictSplitsData>>
): UseMutationOptions<
  ComputeDistrictSplitsResponse,
  ComputeDistrictSplitsError,
  Options<ComputeDistrictSplitsData>
> => {
  const mutationOptions: UseMutationOptions<
    ComputeDistrictSplitsResponse,
    ComputeDistrictSplitsError,
    Options<ComputeDistrictSplitsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await computeDistrictSplits({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDistrictsWithRequestedSegmentsQueryKey = (options?: Options<GetDistrictsWithRequestedSegmentsData>) =>
  createQueryKey('getDistrictsWithRequestedSegments', options)

/**
 * Get Districts With Requested Segments
 */
export const getDistrictsWithRequestedSegmentsOptions = (options?: Options<GetDistrictsWithRequestedSegmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDistrictsWithRequestedSegments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDistrictsWithRequestedSegmentsQueryKey(options),
  })
}

export const getPendingRecomputeQueryKey = (options?: Options<GetPendingRecomputeData>) =>
  createQueryKey('getPendingRecompute', options)

/**
 * Get Pending Recompute
 */
export const getPendingRecomputeOptions = (options?: Options<GetPendingRecomputeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPendingRecompute({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPendingRecomputeQueryKey(options),
  })
}

export const getAllSplitProblemsQueryKey = (options: Options<GetAllSplitProblemsData>) =>
  createQueryKey('getAllSplitProblems', options)

/**
 * Get All Split Problems
 */
export const getAllSplitProblemsOptions = (options: Options<GetAllSplitProblemsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllSplitProblems({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllSplitProblemsQueryKey(options),
  })
}

export const getDsTariffRootMapQueryKey = (options: Options<GetDsTariffRootMapData>) =>
  createQueryKey('getDsTariffRootMap', options)

/**
 * Get Ds Tariff Root Map
 */
export const getDsTariffRootMapOptions = (options: Options<GetDsTariffRootMapData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDsTariffRootMap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDsTariffRootMapQueryKey(options),
  })
}

export const getDsDriveTimesQueryKey = (options: Options<GetDsDriveTimesData>) =>
  createQueryKey('getDsDriveTimes', options)

/**
 * Get Ds Drive Times
 */
export const getDsDriveTimesOptions = (options: Options<GetDsDriveTimesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDsDriveTimes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDsDriveTimesQueryKey(options),
  })
}

export const getDsDriveOverviewQueryKey = (options: Options<GetDsDriveOverviewData>) =>
  createQueryKey('getDsDriveOverview', options)

/**
 * Get Ds Drive Overview
 */
export const getDsDriveOverviewOptions = (options: Options<GetDsDriveOverviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDsDriveOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDsDriveOverviewQueryKey(options),
  })
}

export const getDsBigClosuresQueryKey = (options: Options<GetDsBigClosuresData>) =>
  createQueryKey('getDsBigClosures', options)

/**
 * Get Ds Big Closures
 */
export const getDsBigClosuresOptions = (options: Options<GetDsBigClosuresData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDsBigClosures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDsBigClosuresQueryKey(options),
  })
}

export const getDsRouteMapQueryKey = (options?: Options<GetDsRouteMapData>) => createQueryKey('getDsRouteMap', options)

/**
 * Get Ds Route Map
 */
export const getDsRouteMapOptions = (options?: Options<GetDsRouteMapData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDsRouteMap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDsRouteMapQueryKey(options),
  })
}

export const routesMapDataQueryKey = (options?: Options<RoutesMapDataData>) => createQueryKey('routesMapData', options)

/**
 * Routes Map Data
 */
export const routesMapDataOptions = (options?: Options<RoutesMapDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await routesMapData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: routesMapDataQueryKey(options),
  })
}

export const routesMapViewportQueryKey = (options: Options<RoutesMapViewportData>) =>
  createQueryKey('routesMapViewport', options)

/**
 * Routes Map Viewport
 */
export const routesMapViewportOptions = (options: Options<RoutesMapViewportData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await routesMapViewport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: routesMapViewportQueryKey(options),
  })
}

/**
 * Routes Map Viewport
 */
export const routesMapViewportMutation = (
  options?: Partial<Options<RoutesMapViewportData>>
): UseMutationOptions<RoutesMapViewportResponse2, RoutesMapViewportError, Options<RoutesMapViewportData>> => {
  const mutationOptions: UseMutationOptions<
    RoutesMapViewportResponse2,
    RoutesMapViewportError,
    Options<RoutesMapViewportData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await routesMapViewport({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const routesMapRouteDetailQueryKey = (options: Options<RoutesMapRouteDetailData>) =>
  createQueryKey('routesMapRouteDetail', options)

/**
 * Routes Map Route Detail
 */
export const routesMapRouteDetailOptions = (options: Options<RoutesMapRouteDetailData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await routesMapRouteDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: routesMapRouteDetailQueryKey(options),
  })
}

export const routesMapSearchQueryKey = (options: Options<RoutesMapSearchData>) =>
  createQueryKey('routesMapSearch', options)

/**
 * Routes Map Search
 */
export const routesMapSearchOptions = (options: Options<RoutesMapSearchData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await routesMapSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: routesMapSearchQueryKey(options),
  })
}

export const updateStreetSegmentQueryKey = (options: Options<UpdateStreetSegmentData>) =>
  createQueryKey('updateStreetSegment', options)

/**
 * Update Street Segment
 */
export const updateStreetSegmentOptions = (options: Options<UpdateStreetSegmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateStreetSegment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateStreetSegmentQueryKey(options),
  })
}

/**
 * Update Street Segment
 */
export const updateStreetSegmentMutation = (
  options?: Partial<Options<UpdateStreetSegmentData>>
): UseMutationOptions<UpdateStreetSegmentResponse, UpdateStreetSegmentError, Options<UpdateStreetSegmentData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateStreetSegmentResponse,
    UpdateStreetSegmentError,
    Options<UpdateStreetSegmentData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateStreetSegment({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Street Segment Override
 * Delete a street segment override (and the matching snapshot override row on the Prague instance).
 */
export const deleteStreetSegmentOverrideMutation = (
  options?: Partial<Options<DeleteStreetSegmentOverrideData>>
): UseMutationOptions<
  DeleteStreetSegmentOverrideResponse,
  DeleteStreetSegmentOverrideError,
  Options<DeleteStreetSegmentOverrideData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteStreetSegmentOverrideResponse,
    DeleteStreetSegmentOverrideError,
    Options<DeleteStreetSegmentOverrideData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteStreetSegmentOverride({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const upsertStreetSegmentOverrideQueryKey = (options: Options<UpsertStreetSegmentOverrideData>) =>
  createQueryKey('upsertStreetSegmentOverride', options)

/**
 * Upsert Street Segment Override
 * Upsert a street segment override.
 *
 * Overrides are applied on read by the street_segments / street_segment_drive_requirements views.
 * On the Prague instance the matching snapshot override row is upserted in the same transaction so
 * the control data and snapshot override hashes stay aligned.
 */
export const upsertStreetSegmentOverrideOptions = (options: Options<UpsertStreetSegmentOverrideData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await upsertStreetSegmentOverride({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: upsertStreetSegmentOverrideQueryKey(options),
  })
}

/**
 * Upsert Street Segment Override
 * Upsert a street segment override.
 *
 * Overrides are applied on read by the street_segments / street_segment_drive_requirements views.
 * On the Prague instance the matching snapshot override row is upserted in the same transaction so
 * the control data and snapshot override hashes stay aligned.
 */
export const upsertStreetSegmentOverrideMutation = (
  options?: Partial<Options<UpsertStreetSegmentOverrideData>>
): UseMutationOptions<
  UpsertStreetSegmentOverrideResponse,
  UpsertStreetSegmentOverrideError,
  Options<UpsertStreetSegmentOverrideData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertStreetSegmentOverrideResponse,
    UpsertStreetSegmentOverrideError,
    Options<UpsertStreetSegmentOverrideData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await upsertStreetSegmentOverride({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateTechnicalSegmentQueryKey = (options: Options<UpdateTechnicalSegmentData>) =>
  createQueryKey('updateTechnicalSegment', options)

/**
 * Update Technical Segment
 */
export const updateTechnicalSegmentOptions = (options: Options<UpdateTechnicalSegmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateTechnicalSegment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateTechnicalSegmentQueryKey(options),
  })
}

/**
 * Update Technical Segment
 */
export const updateTechnicalSegmentMutation = (
  options?: Partial<Options<UpdateTechnicalSegmentData>>
): UseMutationOptions<
  UpdateTechnicalSegmentResponse,
  UpdateTechnicalSegmentError,
  Options<UpdateTechnicalSegmentData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateTechnicalSegmentResponse,
    UpdateTechnicalSegmentError,
    Options<UpdateTechnicalSegmentData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateTechnicalSegment({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateRegulatedZoneQueryKey = (options: Options<UpdateRegulatedZoneData>) =>
  createQueryKey('updateRegulatedZone', options)

/**
 * Update Regulated Zone
 */
export const updateRegulatedZoneOptions = (options: Options<UpdateRegulatedZoneData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateRegulatedZone({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateRegulatedZoneQueryKey(options),
  })
}

/**
 * Update Regulated Zone
 */
export const updateRegulatedZoneMutation = (
  options?: Partial<Options<UpdateRegulatedZoneData>>
): UseMutationOptions<UpdateRegulatedZoneResponse, UpdateRegulatedZoneError, Options<UpdateRegulatedZoneData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateRegulatedZoneResponse,
    UpdateRegulatedZoneError,
    Options<UpdateRegulatedZoneData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateRegulatedZone({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateSignPostQueryKey = (options: Options<UpdateSignPostData>) =>
  createQueryKey('updateSignPost', options)

/**
 * Update Sign Post
 */
export const updateSignPostOptions = (options: Options<UpdateSignPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateSignPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateSignPostQueryKey(options),
  })
}

/**
 * Update Sign Post
 */
export const updateSignPostMutation = (
  options?: Partial<Options<UpdateSignPostData>>
): UseMutationOptions<UpdateSignPostResponse, UpdateSignPostError, Options<UpdateSignPostData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateSignPostResponse,
    UpdateSignPostError,
    Options<UpdateSignPostData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateSignPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateControlDataStructureQueryKey = (options?: Options<UpdateControlDataStructureData>) =>
  createQueryKey('updateControlDataStructure', options)

/**
 * Update Control Data Structure
 */
export const updateControlDataStructureOptions = (options?: Options<UpdateControlDataStructureData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateControlDataStructure({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateControlDataStructureQueryKey(options),
  })
}

/**
 * Update Control Data Structure
 */
export const updateControlDataStructureMutation = (
  options?: Partial<Options<UpdateControlDataStructureData>>
): UseMutationOptions<
  UpdateControlDataStructureResponse,
  UpdateControlDataStructureError,
  Options<UpdateControlDataStructureData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateControlDataStructureResponse,
    UpdateControlDataStructureError,
    Options<UpdateControlDataStructureData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateControlDataStructure({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateToOverrideBasedControlDataStructureQueryKey = (
  options?: Options<UpdateToOverrideBasedControlDataStructureData>
) => createQueryKey('updateToOverrideBasedControlDataStructure', options)

/**
 * Update To Override Based Control Data Structure
 * [TEMPORARY] Special, single purpose endpoint to update the control data structure
 * to the override-based control data structure.
 *
 * WARNING: This enpoint must be called exacly once AFTER updaging DB to alembic version
 * 2026-08-25_override_based_control_data_3f9c1e7a2b84 and BEFORE control data structure update endpoint.
 *
 * TODO: Remove this in the next version
 */
export const updateToOverrideBasedControlDataStructureOptions = (
  options?: Options<UpdateToOverrideBasedControlDataStructureData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateToOverrideBasedControlDataStructure({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateToOverrideBasedControlDataStructureQueryKey(options),
  })
}

/**
 * Update To Override Based Control Data Structure
 * [TEMPORARY] Special, single purpose endpoint to update the control data structure
 * to the override-based control data structure.
 *
 * WARNING: This enpoint must be called exacly once AFTER updaging DB to alembic version
 * 2026-08-25_override_based_control_data_3f9c1e7a2b84 and BEFORE control data structure update endpoint.
 *
 * TODO: Remove this in the next version
 */
export const updateToOverrideBasedControlDataStructureMutation = (
  options?: Partial<Options<UpdateToOverrideBasedControlDataStructureData>>
): UseMutationOptions<
  UpdateToOverrideBasedControlDataStructureResponse,
  UpdateToOverrideBasedControlDataStructureError,
  Options<UpdateToOverrideBasedControlDataStructureData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateToOverrideBasedControlDataStructureResponse,
    UpdateToOverrideBasedControlDataStructureError,
    Options<UpdateToOverrideBasedControlDataStructureData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateToOverrideBasedControlDataStructure({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const rollbackToLegacyControlDataStructureQueryKey = (
  options?: Options<RollbackToLegacyControlDataStructureData>
) => createQueryKey('rollbackToLegacyControlDataStructure', options)

/**
 * Rollback To Legacy Control Data Structure
 * [TEMPORARY] Special, single purpose endpoint to rollback from the override-based control data structure
 * to the legacy control data structure.
 *
 * WARNING: This enpoint must be called exacly once in case of rolling back before
 * 2026-08-25_override_based_control_data_3f9c1e7a2b84 AFTER downgrading DB and BEFORE control data structure
 * update endpoint.
 *
 * TODO: Remove this in the next version
 */
export const rollbackToLegacyControlDataStructureOptions = (
  options?: Options<RollbackToLegacyControlDataStructureData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await rollbackToLegacyControlDataStructure({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: rollbackToLegacyControlDataStructureQueryKey(options),
  })
}

/**
 * Rollback To Legacy Control Data Structure
 * [TEMPORARY] Special, single purpose endpoint to rollback from the override-based control data structure
 * to the legacy control data structure.
 *
 * WARNING: This enpoint must be called exacly once in case of rolling back before
 * 2026-08-25_override_based_control_data_3f9c1e7a2b84 AFTER downgrading DB and BEFORE control data structure
 * update endpoint.
 *
 * TODO: Remove this in the next version
 */
export const rollbackToLegacyControlDataStructureMutation = (
  options?: Partial<Options<RollbackToLegacyControlDataStructureData>>
): UseMutationOptions<
  RollbackToLegacyControlDataStructureResponse,
  RollbackToLegacyControlDataStructureError,
  Options<RollbackToLegacyControlDataStructureData>
> => {
  const mutationOptions: UseMutationOptions<
    RollbackToLegacyControlDataStructureResponse,
    RollbackToLegacyControlDataStructureError,
    Options<RollbackToLegacyControlDataStructureData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await rollbackToLegacyControlDataStructure({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const copyAndUpdateControlDataStructureQueryKey = (options: Options<CopyAndUpdateControlDataStructureData>) =>
  createQueryKey('copyAndUpdateControlDataStructure', options)

/**
 * Copy And Update Control Data Structure
 */
export const copyAndUpdateControlDataStructureOptions = (options: Options<CopyAndUpdateControlDataStructureData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await copyAndUpdateControlDataStructure({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: copyAndUpdateControlDataStructureQueryKey(options),
  })
}

/**
 * Copy And Update Control Data Structure
 */
export const copyAndUpdateControlDataStructureMutation = (
  options?: Partial<Options<CopyAndUpdateControlDataStructureData>>
): UseMutationOptions<
  CopyAndUpdateControlDataStructureResponse,
  CopyAndUpdateControlDataStructureError,
  Options<CopyAndUpdateControlDataStructureData>
> => {
  const mutationOptions: UseMutationOptions<
    CopyAndUpdateControlDataStructureResponse,
    CopyAndUpdateControlDataStructureError,
    Options<CopyAndUpdateControlDataStructureData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await copyAndUpdateControlDataStructure({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const importTechnicalSegmentsRegulatedZonesAndSignPostsQueryKey = (
  options: Options<ImportTechnicalSegmentsRegulatedZonesAndSignPostsData>
) => createQueryKey('importTechnicalSegmentsRegulatedZonesAndSignPosts', options)

/**
 * Import Technical Segments Regulated Zones And Sign Posts
 * Update technical_segments, regulated_zones and sign_posts from geojson files
 * EP requires sign_post_file and either technical_segments_file or regulated_zones_file.
 * If both are provided, regulated_zones_file will be ignored.
 *
 * Params:
 * - append_only (bool, optional): Do not delete pre-existing data not present in the files,
 * defaults to False.
 * - invalid_geometry_handling (InvalidGeometryHandling, optional):
 * Ignore invalid geometries in the input data (i.e. parking spaces),
 * defaults to InvalidGeometryHandling.STRICT.
 *
 * Street pairing parameters (See Pairing Mechanism Overview for details):
 *
 * - segment_sample_length (float | None, optional): Segment sample length [m], defaults to 10m.
 * - init_proximity_distance (float | None, optional): Distance in which to look for street
 * segments [SRS unit], defaults to 0.0004.
 * - max_distance_avg (float | None, optional): Max distance to look for single perfect match
 * [SRS unit], defaults to 0.00008.
 *
 * Body:
 * - sign_posts_file (File|binary, "application/geojson"): Sign posts geojson.
 * - technical_segments_file (File|binary, "application/geojson", optional):
 * Technical segments geojson.
 * - regulated_zones_file (File|binary, "application/geojson", optional):
 * Regulated zones geojson.
 *
 * > **Pairing Mechanism Overview**
 * >
 * > The mechanism pairs technical segments with street segments by comparing their geometric
 * > similarity. Different datasets may require slightly different parameters to achieve the
 * > best results.
 * > Final metric for pairing success/confidence is the count of
 * > technical_segments.is_suspicious_pairing compared to total count of inserted/updated
 * > technical_segments (lower is better)
 * >
 * > Parameters:
 * > - **segment_sample_length** (default: 10.0):
 * >   Controls the density of sample points along both technical and street segment axes.
 * >   Higher values = fewer sample points, lower values = more detailed sampling
 * > - **init_proximity_distance** (default: 0.0004):
 * >   Initial spatial filter using ST_DWithin() to find candidate street segments.
 * >   Only street segments within this distance from the technical segment are considered.
 * >   Acts as a performance optimization to avoid comparing distant segments
 * > - **max_distance_avg** (default: 0.00008):
 * >   Final quality threshold for pairing decisions.
 * >   Compares average distance between sample points of technical and street segment axes.
 * >   Only pairs with distance_avg < max_distance_avg are considered valid.
 * >   Much smaller than init_proximity_distance for precise matching
 *
 * > Known parameter values:
 * > - Nitra: segment_sample_length=12.0, init_proximity_distance=0.0003,
 * >   max_distance_avg=0.000089
 * > - Prague: segment_sample_length=10, init_proximity_distance=0.0004,
 * >   max_distance_avg=0.00008
 * > - Bratislava: segment_sample_length=9, init_proximity_distance=0.0003,
 * >   max_distance_avg=0.000088
 * > this is based on empirical testing and is not guaranteed to be optimal for future datasets
 */
export const importTechnicalSegmentsRegulatedZonesAndSignPostsOptions = (
  options: Options<ImportTechnicalSegmentsRegulatedZonesAndSignPostsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await importTechnicalSegmentsRegulatedZonesAndSignPosts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: importTechnicalSegmentsRegulatedZonesAndSignPostsQueryKey(options),
  })
}

/**
 * Import Technical Segments Regulated Zones And Sign Posts
 * Update technical_segments, regulated_zones and sign_posts from geojson files
 * EP requires sign_post_file and either technical_segments_file or regulated_zones_file.
 * If both are provided, regulated_zones_file will be ignored.
 *
 * Params:
 * - append_only (bool, optional): Do not delete pre-existing data not present in the files,
 * defaults to False.
 * - invalid_geometry_handling (InvalidGeometryHandling, optional):
 * Ignore invalid geometries in the input data (i.e. parking spaces),
 * defaults to InvalidGeometryHandling.STRICT.
 *
 * Street pairing parameters (See Pairing Mechanism Overview for details):
 *
 * - segment_sample_length (float | None, optional): Segment sample length [m], defaults to 10m.
 * - init_proximity_distance (float | None, optional): Distance in which to look for street
 * segments [SRS unit], defaults to 0.0004.
 * - max_distance_avg (float | None, optional): Max distance to look for single perfect match
 * [SRS unit], defaults to 0.00008.
 *
 * Body:
 * - sign_posts_file (File|binary, "application/geojson"): Sign posts geojson.
 * - technical_segments_file (File|binary, "application/geojson", optional):
 * Technical segments geojson.
 * - regulated_zones_file (File|binary, "application/geojson", optional):
 * Regulated zones geojson.
 *
 * > **Pairing Mechanism Overview**
 * >
 * > The mechanism pairs technical segments with street segments by comparing their geometric
 * > similarity. Different datasets may require slightly different parameters to achieve the
 * > best results.
 * > Final metric for pairing success/confidence is the count of
 * > technical_segments.is_suspicious_pairing compared to total count of inserted/updated
 * > technical_segments (lower is better)
 * >
 * > Parameters:
 * > - **segment_sample_length** (default: 10.0):
 * >   Controls the density of sample points along both technical and street segment axes.
 * >   Higher values = fewer sample points, lower values = more detailed sampling
 * > - **init_proximity_distance** (default: 0.0004):
 * >   Initial spatial filter using ST_DWithin() to find candidate street segments.
 * >   Only street segments within this distance from the technical segment are considered.
 * >   Acts as a performance optimization to avoid comparing distant segments
 * > - **max_distance_avg** (default: 0.00008):
 * >   Final quality threshold for pairing decisions.
 * >   Compares average distance between sample points of technical and street segment axes.
 * >   Only pairs with distance_avg < max_distance_avg are considered valid.
 * >   Much smaller than init_proximity_distance for precise matching
 *
 * > Known parameter values:
 * > - Nitra: segment_sample_length=12.0, init_proximity_distance=0.0003,
 * >   max_distance_avg=0.000089
 * > - Prague: segment_sample_length=10, init_proximity_distance=0.0004,
 * >   max_distance_avg=0.00008
 * > - Bratislava: segment_sample_length=9, init_proximity_distance=0.0003,
 * >   max_distance_avg=0.000088
 * > this is based on empirical testing and is not guaranteed to be optimal for future datasets
 */
export const importTechnicalSegmentsRegulatedZonesAndSignPostsMutation = (
  options?: Partial<Options<ImportTechnicalSegmentsRegulatedZonesAndSignPostsData>>
): UseMutationOptions<
  ImportTechnicalSegmentsRegulatedZonesAndSignPostsResponse,
  ImportTechnicalSegmentsRegulatedZonesAndSignPostsError,
  Options<ImportTechnicalSegmentsRegulatedZonesAndSignPostsData>
> => {
  const mutationOptions: UseMutationOptions<
    ImportTechnicalSegmentsRegulatedZonesAndSignPostsResponse,
    ImportTechnicalSegmentsRegulatedZonesAndSignPostsError,
    Options<ImportTechnicalSegmentsRegulatedZonesAndSignPostsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await importTechnicalSegmentsRegulatedZonesAndSignPosts({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const freezeTechnicalSegmentStreetPairingQueryKey = (
  options?: Options<FreezeTechnicalSegmentStreetPairingData>
) => createQueryKey('freezeTechnicalSegmentStreetPairing', options)

/**
 * Freeze Technical Segment Street Pairing
 * Freeze technical segment street pairing
 *
 * Freezes technical segments that are not suspicious and not already frozen.
 *
 * Params:
 * - district_id (int | None, optional): District ID. If present, freeze technical segments only for this district
 * - tariff_zone (str | None, optional): Tariff zone. If present, freeze technical segments only for this tariff zone
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const freezeTechnicalSegmentStreetPairingOptions = (
  options?: Options<FreezeTechnicalSegmentStreetPairingData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await freezeTechnicalSegmentStreetPairing({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: freezeTechnicalSegmentStreetPairingQueryKey(options),
  })
}

/**
 * Freeze Technical Segment Street Pairing
 * Freeze technical segment street pairing
 *
 * Freezes technical segments that are not suspicious and not already frozen.
 *
 * Params:
 * - district_id (int | None, optional): District ID. If present, freeze technical segments only for this district
 * - tariff_zone (str | None, optional): Tariff zone. If present, freeze technical segments only for this tariff zone
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const freezeTechnicalSegmentStreetPairingMutation = (
  options?: Partial<Options<FreezeTechnicalSegmentStreetPairingData>>
): UseMutationOptions<
  FreezeTechnicalSegmentStreetPairingResponse,
  FreezeTechnicalSegmentStreetPairingError,
  Options<FreezeTechnicalSegmentStreetPairingData>
> => {
  const mutationOptions: UseMutationOptions<
    FreezeTechnicalSegmentStreetPairingResponse,
    FreezeTechnicalSegmentStreetPairingError,
    Options<FreezeTechnicalSegmentStreetPairingData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await freezeTechnicalSegmentStreetPairing({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const pairTechnicalSegments2StreetSegmentsQueryKey = (
  options?: Options<PairTechnicalSegments2StreetSegmentsData>
) => createQueryKey('pairTechnicalSegments2StreetSegments', options)

/**
 * Pair Technical Segments2Street Segments
 * Pair technical segments to street segments
 *
 * for detailed description and optimal parameter values see
 * `/api/control-data-edit/import-trs` docs
 *
 * Params:
 * - dry (bool, optional): Dry run, set to False to persist the results, default=True
 * - limit_ts (int | None, optional): Limit the number of technical segments to pair
 * (incompatible with dry=False), default=None, gt=0
 * - segment_sample_length (float | None, optional): Segment sample length [m], defaults to 10m
 * - init_proximity_distance (float | None, optional): Distance in which to look for street
 * segments [SRS unit], defaults to 0.0004
 * - max_distance_avg (float | None, optional): Max distance to look for single perfect
 * match [SRS unit], defaults to 0.00008
 * - exclude_frozen (bool, optional): Exclude frozen technical segments, default=True
 * - district_id (int | None, optional): District ID. If present, pair technical segments only for this district
 * - tariff_zone (str | None, optional): Tariff zone. If present, pair technical segments only for this tariff zone
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const pairTechnicalSegments2StreetSegmentsOptions = (
  options?: Options<PairTechnicalSegments2StreetSegmentsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pairTechnicalSegments2StreetSegments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: pairTechnicalSegments2StreetSegmentsQueryKey(options),
  })
}

/**
 * Pair Technical Segments2Street Segments
 * Pair technical segments to street segments
 *
 * for detailed description and optimal parameter values see
 * `/api/control-data-edit/import-trs` docs
 *
 * Params:
 * - dry (bool, optional): Dry run, set to False to persist the results, default=True
 * - limit_ts (int | None, optional): Limit the number of technical segments to pair
 * (incompatible with dry=False), default=None, gt=0
 * - segment_sample_length (float | None, optional): Segment sample length [m], defaults to 10m
 * - init_proximity_distance (float | None, optional): Distance in which to look for street
 * segments [SRS unit], defaults to 0.0004
 * - max_distance_avg (float | None, optional): Max distance to look for single perfect
 * match [SRS unit], defaults to 0.00008
 * - exclude_frozen (bool, optional): Exclude frozen technical segments, default=True
 * - district_id (int | None, optional): District ID. If present, pair technical segments only for this district
 * - tariff_zone (str | None, optional): Tariff zone. If present, pair technical segments only for this tariff zone
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const pairTechnicalSegments2StreetSegmentsMutation = (
  options?: Partial<Options<PairTechnicalSegments2StreetSegmentsData>>
): UseMutationOptions<
  PairTechnicalSegments2StreetSegmentsResponse,
  PairTechnicalSegments2StreetSegmentsError,
  Options<PairTechnicalSegments2StreetSegmentsData>
> => {
  const mutationOptions: UseMutationOptions<
    PairTechnicalSegments2StreetSegmentsResponse,
    PairTechnicalSegments2StreetSegmentsError,
    Options<PairTechnicalSegments2StreetSegmentsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await pairTechnicalSegments2StreetSegments({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const computeSsdrQueryKey = (options?: Options<ComputeSsdrData>) => createQueryKey('computeSsdr', options)

/**
 * Compute Ssdr
 * Compute Street Segment Drive Requirements
 *
 * Params:
 * - db (DBSessionWithControlDataSchema): Database session
 * - settings (AppSettings): Application settings
 * - district_id (int | None, optional): District ID. If present, compute SSDR only for this district, default=None
 * - include_technical_segments (bool, optional): Include technical segments, default=True
 * - include_regulated_zones (bool, optional): Include regulated zones, default=True
 * - include_sign_posts (bool, optional): Include sign posts, default=True
 * - exclude_frozen (bool, optional): Exclude frozen SSDR, default=True
 * - rz_ssdr_mode (RegulatedZoneSSDRMode, optional): Regulated zone SSDR mode, default=SIGNLE_CANDIDATE
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const computeSsdrOptions = (options?: Options<ComputeSsdrData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await computeSsdr({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: computeSsdrQueryKey(options),
  })
}

/**
 * Compute Ssdr
 * Compute Street Segment Drive Requirements
 *
 * Params:
 * - db (DBSessionWithControlDataSchema): Database session
 * - settings (AppSettings): Application settings
 * - district_id (int | None, optional): District ID. If present, compute SSDR only for this district, default=None
 * - include_technical_segments (bool, optional): Include technical segments, default=True
 * - include_regulated_zones (bool, optional): Include regulated zones, default=True
 * - include_sign_posts (bool, optional): Include sign posts, default=True
 * - exclude_frozen (bool, optional): Exclude frozen SSDR, default=True
 * - rz_ssdr_mode (RegulatedZoneSSDRMode, optional): Regulated zone SSDR mode, default=SIGNLE_CANDIDATE
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const computeSsdrMutation = (
  options?: Partial<Options<ComputeSsdrData>>
): UseMutationOptions<ComputeSsdrResponse, ComputeSsdrError, Options<ComputeSsdrData>> => {
  const mutationOptions: UseMutationOptions<ComputeSsdrResponse, ComputeSsdrError, Options<ComputeSsdrData>> = {
    mutationFn: async localOptions => {
      const { data } = await computeSsdr({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const compareRowsQueryKey = (options: Options<CompareRowsData>) => createQueryKey('compareRows', options)

/**
 * Compare Rows
 * Compare rows between two control_data_* schemas for a given table.
 *
 * Returns paginated diff rows with left_data and right_data for each row,
 * along with the total count of matching rows (before pagination).
 * Optional `columns` is a comma-separated list of column names to include.
 */
export const compareRowsOptions = (options: Options<CompareRowsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await compareRows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: compareRowsQueryKey(options),
  })
}

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = {
    ...queryKey[0],
  }
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    }
  }
  return params as unknown as typeof page
}

export const compareRowsInfiniteQueryKey = (options: Options<CompareRowsData>): QueryKey<Options<CompareRowsData>> =>
  createQueryKey('compareRows', options, true)

/**
 * Compare Rows
 * Compare rows between two control_data_* schemas for a given table.
 *
 * Returns paginated diff rows with left_data and right_data for each row,
 * along with the total count of matching rows (before pagination).
 * Optional `columns` is a comma-separated list of column names to include.
 */
export const compareRowsInfiniteOptions = (options: Options<CompareRowsData>) => {
  return infiniteQueryOptions<
    CompareRowsResponse2,
    CompareRowsError,
    InfiniteData<CompareRowsResponse2>,
    QueryKey<Options<CompareRowsData>>,
    number | Pick<QueryKey<Options<CompareRowsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<CompareRowsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await compareRows({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: compareRowsInfiniteQueryKey(options),
    }
  )
}

export const applyCompareChangeQueryKey = (options: Options<ApplyCompareChangeData>) =>
  createQueryKey('applyCompareChange', options)

/**
 * Apply Compare Change
 * Apply a change (copy/update/delete) from one control_data_* schema to another.
 *
 * Production schema protection applies to the target schema only.
 */
export const applyCompareChangeOptions = (options: Options<ApplyCompareChangeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applyCompareChange({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: applyCompareChangeQueryKey(options),
  })
}

/**
 * Apply Compare Change
 * Apply a change (copy/update/delete) from one control_data_* schema to another.
 *
 * Production schema protection applies to the target schema only.
 */
export const applyCompareChangeMutation = (
  options?: Partial<Options<ApplyCompareChangeData>>
): UseMutationOptions<ApplyCompareChangeResponse, ApplyCompareChangeError, Options<ApplyCompareChangeData>> => {
  const mutationOptions: UseMutationOptions<
    ApplyCompareChangeResponse,
    ApplyCompareChangeError,
    Options<ApplyCompareChangeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await applyCompareChange({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const pullControlDataQueryKey = (options?: Options<PullControlDataData>) =>
  createQueryKey('pullControlData', options)

/**
 * Pull Control Data
 * Pull control data from the source schema to the target schema
 */
export const pullControlDataOptions = (options?: Options<PullControlDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pullControlData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: pullControlDataQueryKey(options),
  })
}

/**
 * Pull Control Data
 * Pull control data from the source schema to the target schema
 */
export const pullControlDataMutation = (
  options?: Partial<Options<PullControlDataData>>
): UseMutationOptions<PullControlDataResponse, PullControlDataError, Options<PullControlDataData>> => {
  const mutationOptions: UseMutationOptions<
    PullControlDataResponse,
    PullControlDataError,
    Options<PullControlDataData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await pullControlData({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Control Data Schema
 * Delete (drop) the whole specified control_data_* schema.
 *
 * The production control data schema is protected and cannot be deleted.
 */
export const deleteControlDataSchemaMutation = (
  options?: Partial<Options<DeleteControlDataSchemaData>>
): UseMutationOptions<
  DeleteControlDataSchemaResponse,
  DeleteControlDataSchemaError,
  Options<DeleteControlDataSchemaData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteControlDataSchemaResponse,
    DeleteControlDataSchemaError,
    Options<DeleteControlDataSchemaData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteControlDataSchema({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAllVehiclesQueryKey = (options?: Options<GetAllVehiclesData>) =>
  createQueryKey('getAllVehicles', options)

/**
 * Get All Vehicles
 */
export const getAllVehiclesOptions = (options?: Options<GetAllVehiclesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllVehicles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllVehiclesQueryKey(options),
  })
}

export const getVehicleQueryKey = (options: Options<GetVehicleData>) => createQueryKey('getVehicle', options)

/**
 * Get Vehicle
 */
export const getVehicleOptions = (options: Options<GetVehicleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVehicle({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getVehicleQueryKey(options),
  })
}

/**
 * Update Vehicle
 */
export const updateVehicleMutation = (
  options?: Partial<Options<UpdateVehicleData>>
): UseMutationOptions<UpdateVehicleResponse, UpdateVehicleError, Options<UpdateVehicleData>> => {
  const mutationOptions: UseMutationOptions<UpdateVehicleResponse, UpdateVehicleError, Options<UpdateVehicleData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateVehicle({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getVehicleLastStatusQueryKey = (options: Options<GetVehicleLastStatusData>) =>
  createQueryKey('getVehicleLastStatus', options)

/**
 * Get Vehicle Last Status
 */
export const getVehicleLastStatusOptions = (options: Options<GetVehicleLastStatusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVehicleLastStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getVehicleLastStatusQueryKey(options),
  })
}

export const getVehicleMetricsQueryKey = (options: Options<GetVehicleMetricsData>) =>
  createQueryKey('getVehicleMetrics', options)

/**
 * Get Vehicle Metrics
 */
export const getVehicleMetricsOptions = (options: Options<GetVehicleMetricsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVehicleMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getVehicleMetricsQueryKey(options),
  })
}

export const getVehicleNavigationDataQueryKey = (options: Options<GetVehicleNavigationDataData>) =>
  createQueryKey('getVehicleNavigationData', options)

/**
 * Get Vehicle Navigation Data
 */
export const getVehicleNavigationDataOptions = (options: Options<GetVehicleNavigationDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVehicleNavigationData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getVehicleNavigationDataQueryKey(options),
  })
}

/**
 * Set Vehicle Maintenance Mode
 */
export const setVehicleMaintenanceModeMutation = (
  options?: Partial<Options<SetVehicleMaintenanceModeData>>
): UseMutationOptions<
  SetVehicleMaintenanceModeResponse,
  SetVehicleMaintenanceModeError,
  Options<SetVehicleMaintenanceModeData>
> => {
  const mutationOptions: UseMutationOptions<
    SetVehicleMaintenanceModeResponse,
    SetVehicleMaintenanceModeError,
    Options<SetVehicleMaintenanceModeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await setVehicleMaintenanceMode({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAllDriversQueryKey = (options?: Options<GetAllDriversData>) => createQueryKey('getAllDrivers', options)

/**
 * Get All Drivers
 */
export const getAllDriversOptions = (options?: Options<GetAllDriversData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllDrivers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllDriversQueryKey(options),
  })
}

export const createDriverQueryKey = (options: Options<CreateDriverData>) => createQueryKey('createDriver', options)

/**
 * Create Driver
 */
export const createDriverOptions = (options: Options<CreateDriverData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createDriver({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createDriverQueryKey(options),
  })
}

/**
 * Create Driver
 */
export const createDriverMutation = (
  options?: Partial<Options<CreateDriverData>>
): UseMutationOptions<CreateDriverResponse, CreateDriverError, Options<CreateDriverData>> => {
  const mutationOptions: UseMutationOptions<CreateDriverResponse, CreateDriverError, Options<CreateDriverData>> = {
    mutationFn: async localOptions => {
      const { data } = await createDriver({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getExternalDriversQueryKey = (options?: Options<GetExternalDriversData>) =>
  createQueryKey('getExternalDrivers', options)

/**
 * Get External Drivers
 */
export const getExternalDriversOptions = (options?: Options<GetExternalDriversData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExternalDrivers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getExternalDriversQueryKey(options),
  })
}

export const importExternalDriverQueryKey = (options: Options<ImportExternalDriverData>) =>
  createQueryKey('importExternalDriver', options)

/**
 * Import External Driver
 */
export const importExternalDriverOptions = (options: Options<ImportExternalDriverData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await importExternalDriver({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: importExternalDriverQueryKey(options),
  })
}

/**
 * Import External Driver
 */
export const importExternalDriverMutation = (
  options?: Partial<Options<ImportExternalDriverData>>
): UseMutationOptions<ImportExternalDriverResponse, ImportExternalDriverError, Options<ImportExternalDriverData>> => {
  const mutationOptions: UseMutationOptions<
    ImportExternalDriverResponse,
    ImportExternalDriverError,
    Options<ImportExternalDriverData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await importExternalDriver({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const associateExternalDriverQueryKey = (options: Options<AssociateExternalDriverData>) =>
  createQueryKey('associateExternalDriver', options)

/**
 * Associate External Driver
 */
export const associateExternalDriverOptions = (options: Options<AssociateExternalDriverData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await associateExternalDriver({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: associateExternalDriverQueryKey(options),
  })
}

/**
 * Associate External Driver
 */
export const associateExternalDriverMutation = (
  options?: Partial<Options<AssociateExternalDriverData>>
): UseMutationOptions<
  AssociateExternalDriverResponse,
  AssociateExternalDriverError,
  Options<AssociateExternalDriverData>
> => {
  const mutationOptions: UseMutationOptions<
    AssociateExternalDriverResponse,
    AssociateExternalDriverError,
    Options<AssociateExternalDriverData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await associateExternalDriver({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDriverQueryKey = (options: Options<GetDriverData>) => createQueryKey('getDriver', options)

/**
 * Get Driver
 */
export const getDriverOptions = (options: Options<GetDriverData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriver({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDriverQueryKey(options),
  })
}

/**
 * Update Driver
 */
export const updateDriverMutation = (
  options?: Partial<Options<UpdateDriverData>>
): UseMutationOptions<UpdateDriverResponse, UpdateDriverError, Options<UpdateDriverData>> => {
  const mutationOptions: UseMutationOptions<UpdateDriverResponse, UpdateDriverError, Options<UpdateDriverData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateDriver({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getInactiveDriversQueryKey = (options?: Options<GetInactiveDriversData>) =>
  createQueryKey('getInactiveDrivers', options)

/**
 * Get Inactive Drivers
 */
export const getInactiveDriversOptions = (options?: Options<GetInactiveDriversData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInactiveDrivers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getInactiveDriversQueryKey(options),
  })
}

export const getDailyScheduleQueryKey = (options: Options<GetDailyScheduleData>) =>
  createQueryKey('getDailySchedule', options)

/**
 * Get Daily Schedule
 */
export const getDailyScheduleOptions = (options: Options<GetDailyScheduleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDailySchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDailyScheduleQueryKey(options),
  })
}

export const getScheduleForIntervalQueryKey = (options: Options<GetScheduleForIntervalData>) =>
  createQueryKey('getScheduleForInterval', options)

/**
 * Get Schedule For Interval
 */
export const getScheduleForIntervalOptions = (options: Options<GetScheduleForIntervalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScheduleForInterval({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getScheduleForIntervalQueryKey(options),
  })
}

export const getShiftOverviewQueryKey = (options: Options<GetShiftOverviewData>) =>
  createQueryKey('getShiftOverview', options)

/**
 * Get Shift Overview
 */
export const getShiftOverviewOptions = (options: Options<GetShiftOverviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShiftOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getShiftOverviewQueryKey(options),
  })
}

/**
 * Delete Shift
 */
export const deleteShiftMutation = (
  options?: Partial<Options<DeleteShiftData>>
): UseMutationOptions<DeleteShiftResponse, DeleteShiftError, Options<DeleteShiftData>> => {
  const mutationOptions: UseMutationOptions<DeleteShiftResponse, DeleteShiftError, Options<DeleteShiftData>> = {
    mutationFn: async localOptions => {
      const { data } = await deleteShift({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getScheduledDrivesQueryKey = (options?: Options<GetScheduledDrivesData>) =>
  createQueryKey('getScheduledDrives', options)

/**
 * Get Scheduled Drives
 * Get currently scheduled drives, grouped into intervals based on their time requirements.
 * The intervals are guaranteed to have no gaps between them (there may be intervals with no drives).
 */
export const getScheduledDrivesOptions = (options?: Options<GetScheduledDrivesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScheduledDrives({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getScheduledDrivesQueryKey(options),
  })
}

export const scheduleDriveQueryKey = (options: Options<ScheduleDriveData>) => createQueryKey('scheduleDrive', options)

/**
 * Schedule Drive
 */
export const scheduleDriveOptions = (options: Options<ScheduleDriveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await scheduleDrive({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: scheduleDriveQueryKey(options),
  })
}

/**
 * Schedule Drive
 */
export const scheduleDriveMutation = (
  options?: Partial<Options<ScheduleDriveData>>
): UseMutationOptions<ScheduleDriveResponse, ScheduleDriveError, Options<ScheduleDriveData>> => {
  const mutationOptions: UseMutationOptions<ScheduleDriveResponse, ScheduleDriveError, Options<ScheduleDriveData>> = {
    mutationFn: async localOptions => {
      const { data } = await scheduleDrive({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getScheduledDriveQueryKey = (options: Options<GetScheduledDriveData>) =>
  createQueryKey('getScheduledDrive', options)

/**
 * Get Scheduled Drive
 */
export const getScheduledDriveOptions = (options: Options<GetScheduledDriveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScheduledDrive({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getScheduledDriveQueryKey(options),
  })
}

/**
 * Update Scheduled Drive
 */
export const updateScheduledDriveMutation = (
  options?: Partial<Options<UpdateScheduledDriveData>>
): UseMutationOptions<UpdateScheduledDriveResponse, UpdateScheduledDriveError, Options<UpdateScheduledDriveData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateScheduledDriveResponse,
    UpdateScheduledDriveError,
    Options<UpdateScheduledDriveData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateScheduledDrive({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const reorderScheduledDrivesQueryKey = (options: Options<ReorderScheduledDrivesData>) =>
  createQueryKey('reorderScheduledDrives', options)

/**
 * Reorder Scheduled Drives
 */
export const reorderScheduledDrivesOptions = (options: Options<ReorderScheduledDrivesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reorderScheduledDrives({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reorderScheduledDrivesQueryKey(options),
  })
}

/**
 * Reorder Scheduled Drives
 */
export const reorderScheduledDrivesMutation = (
  options?: Partial<Options<ReorderScheduledDrivesData>>
): UseMutationOptions<
  ReorderScheduledDrivesResponse,
  ReorderScheduledDrivesError,
  Options<ReorderScheduledDrivesData>
> => {
  const mutationOptions: UseMutationOptions<
    ReorderScheduledDrivesResponse,
    ReorderScheduledDrivesError,
    Options<ReorderScheduledDrivesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await reorderScheduledDrives({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const rescheduleDriveQueryKey = (options: Options<RescheduleDriveData>) =>
  createQueryKey('rescheduleDrive', options)

/**
 * Reschedule Drive
 */
export const rescheduleDriveOptions = (options: Options<RescheduleDriveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await rescheduleDrive({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: rescheduleDriveQueryKey(options),
  })
}

/**
 * Reschedule Drive
 */
export const rescheduleDriveMutation = (
  options?: Partial<Options<RescheduleDriveData>>
): UseMutationOptions<RescheduleDriveResponse, RescheduleDriveError, Options<RescheduleDriveData>> => {
  const mutationOptions: UseMutationOptions<
    RescheduleDriveResponse,
    RescheduleDriveError,
    Options<RescheduleDriveData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await rescheduleDrive({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const moveScheduleQueryKey = (options: Options<MoveScheduleData>) => createQueryKey('moveSchedule', options)

/**
 * Move Schedule
 */
export const moveScheduleOptions = (options: Options<MoveScheduleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moveSchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: moveScheduleQueryKey(options),
  })
}

/**
 * Move Schedule
 */
export const moveScheduleMutation = (
  options?: Partial<Options<MoveScheduleData>>
): UseMutationOptions<MoveScheduleResponse, MoveScheduleError, Options<MoveScheduleData>> => {
  const mutationOptions: UseMutationOptions<MoveScheduleResponse, MoveScheduleError, Options<MoveScheduleData>> = {
    mutationFn: async localOptions => {
      const { data } = await moveSchedule({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getCurrentDrivesQueryKey = (options?: Options<GetCurrentDrivesData>) =>
  createQueryKey('getCurrentDrives', options)

/**
 * Get Current Drives
 */
export const getCurrentDrivesOptions = (options?: Options<GetCurrentDrivesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentDrives({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getCurrentDrivesQueryKey(options),
  })
}

export const cancelScheduledDriveQueryKey = (options: Options<CancelScheduledDriveData>) =>
  createQueryKey('cancelScheduledDrive', options)

/**
 * Cancel Scheduled Drive
 */
export const cancelScheduledDriveOptions = (options: Options<CancelScheduledDriveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await cancelScheduledDrive({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: cancelScheduledDriveQueryKey(options),
  })
}

/**
 * Cancel Scheduled Drive
 */
export const cancelScheduledDriveMutation = (
  options?: Partial<Options<CancelScheduledDriveData>>
): UseMutationOptions<CancelScheduledDriveResponse, CancelScheduledDriveError, Options<CancelScheduledDriveData>> => {
  const mutationOptions: UseMutationOptions<
    CancelScheduledDriveResponse,
    CancelScheduledDriveError,
    Options<CancelScheduledDriveData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await cancelScheduledDrive({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const approveScheduledDriveQueryKey = (options: Options<ApproveScheduledDriveData>) =>
  createQueryKey('approveScheduledDrive', options)

/**
 * Approve Scheduled Drive
 */
export const approveScheduledDriveOptions = (options: Options<ApproveScheduledDriveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await approveScheduledDrive({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: approveScheduledDriveQueryKey(options),
  })
}

/**
 * Approve Scheduled Drive
 */
export const approveScheduledDriveMutation = (
  options?: Partial<Options<ApproveScheduledDriveData>>
): UseMutationOptions<
  ApproveScheduledDriveResponse,
  ApproveScheduledDriveError,
  Options<ApproveScheduledDriveData>
> => {
  const mutationOptions: UseMutationOptions<
    ApproveScheduledDriveResponse,
    ApproveScheduledDriveError,
    Options<ApproveScheduledDriveData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await approveScheduledDrive({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const disapproveScheduledDriveQueryKey = (options: Options<DisapproveScheduledDriveData>) =>
  createQueryKey('disapproveScheduledDrive', options)

/**
 * Disapprove Scheduled Drive
 */
export const disapproveScheduledDriveOptions = (options: Options<DisapproveScheduledDriveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await disapproveScheduledDrive({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: disapproveScheduledDriveQueryKey(options),
  })
}

/**
 * Disapprove Scheduled Drive
 */
export const disapproveScheduledDriveMutation = (
  options?: Partial<Options<DisapproveScheduledDriveData>>
): UseMutationOptions<
  DisapproveScheduledDriveResponse,
  DisapproveScheduledDriveError,
  Options<DisapproveScheduledDriveData>
> => {
  const mutationOptions: UseMutationOptions<
    DisapproveScheduledDriveResponse,
    DisapproveScheduledDriveError,
    Options<DisapproveScheduledDriveData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await disapproveScheduledDrive({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDriveIntervalsQueryKey = (options: Options<GetDriveIntervalsData>) =>
  createQueryKey('getDriveIntervals', options)

/**
 * Get Drive Intervals
 */
export const getDriveIntervalsOptions = (options: Options<GetDriveIntervalsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriveIntervals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDriveIntervalsQueryKey(options),
  })
}

export const getRequirementSubintervalsQueryKey = (options: Options<GetRequirementSubintervalsData>) =>
  createQueryKey('getRequirementSubintervals', options)

/**
 * Get Requirement Subintervals
 */
export const getRequirementSubintervalsOptions = (options: Options<GetRequirementSubintervalsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRequirementSubintervals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRequirementSubintervalsQueryKey(options),
  })
}

export const getRequirementFulfillmentPerSegmentQueryKey = (
  options: Options<GetRequirementFulfillmentPerSegmentData>
) => createQueryKey('getRequirementFulfillmentPerSegment', options)

/**
 * Get Requirement Fulfillment Per Segment
 */
export const getRequirementFulfillmentPerSegmentOptions = (
  options: Options<GetRequirementFulfillmentPerSegmentData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRequirementFulfillmentPerSegment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRequirementFulfillmentPerSegmentQueryKey(options),
  })
}

export const getRequirementFulfillmentQueryKey = (options: Options<GetRequirementFulfillmentData>) =>
  createQueryKey('getRequirementFulfillment', options)

/**
 * Get Requirement Fulfillment
 */
export const getRequirementFulfillmentOptions = (options: Options<GetRequirementFulfillmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRequirementFulfillment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRequirementFulfillmentQueryKey(options),
  })
}

export const syncShiftsOnDemandQueryKey = (options?: Options<SyncShiftsOnDemandData>) =>
  createQueryKey('syncShiftsOnDemand', options)

/**
 * Sync Shifts On Demand
 */
export const syncShiftsOnDemandOptions = (options?: Options<SyncShiftsOnDemandData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await syncShiftsOnDemand({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: syncShiftsOnDemandQueryKey(options),
  })
}

export const getPingVehicleQueryKey = (options: Options<GetPingVehicleData>) =>
  createQueryKey('getPingVehicle', options)

/**
 * Get Ping Vehicle
 */
export const getPingVehicleOptions = (options: Options<GetPingVehicleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPingVehicle({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPingVehicleQueryKey(options),
  })
}

export const populateIntervalQueryKey = (options: Options<PopulateIntervalData>) =>
  createQueryKey('populateInterval', options)

/**
 * Populate Interval
 */
export const populateIntervalOptions = (options: Options<PopulateIntervalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await populateInterval({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: populateIntervalQueryKey(options),
  })
}

/**
 * Populate Interval
 */
export const populateIntervalMutation = (
  options?: Partial<Options<PopulateIntervalData>>
): UseMutationOptions<PopulateIntervalResponse, PopulateIntervalError, Options<PopulateIntervalData>> => {
  const mutationOptions: UseMutationOptions<
    PopulateIntervalResponse,
    PopulateIntervalError,
    Options<PopulateIntervalData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await populateInterval({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const manuallyPopulateIntervalQueryKey = (options: Options<ManuallyPopulateIntervalData>) =>
  createQueryKey('manuallyPopulateInterval', options)

/**
 * Manually Populate Interval
 */
export const manuallyPopulateIntervalOptions = (options: Options<ManuallyPopulateIntervalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await manuallyPopulateInterval({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: manuallyPopulateIntervalQueryKey(options),
  })
}

/**
 * Manually Populate Interval
 */
export const manuallyPopulateIntervalMutation = (
  options?: Partial<Options<ManuallyPopulateIntervalData>>
): UseMutationOptions<
  ManuallyPopulateIntervalResponse,
  ManuallyPopulateIntervalError,
  Options<ManuallyPopulateIntervalData>
> => {
  const mutationOptions: UseMutationOptions<
    ManuallyPopulateIntervalResponse,
    ManuallyPopulateIntervalError,
    Options<ManuallyPopulateIntervalData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await manuallyPopulateInterval({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const scheduleDistrictsQueryKey = (options: Options<ScheduleDistrictsData>) =>
  createQueryKey('scheduleDistricts', options)

/**
 * Schedule Districts
 */
export const scheduleDistrictsOptions = (options: Options<ScheduleDistrictsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await scheduleDistricts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: scheduleDistrictsQueryKey(options),
  })
}

/**
 * Schedule Districts
 */
export const scheduleDistrictsMutation = (
  options?: Partial<Options<ScheduleDistrictsData>>
): UseMutationOptions<ScheduleDistrictsResponse, ScheduleDistrictsError, Options<ScheduleDistrictsData>> => {
  const mutationOptions: UseMutationOptions<
    ScheduleDistrictsResponse,
    ScheduleDistrictsError,
    Options<ScheduleDistrictsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await scheduleDistricts({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const copyVehicleScheduleQueryKey = (options: Options<CopyVehicleScheduleData>) =>
  createQueryKey('copyVehicleSchedule', options)

/**
 * Copy Vehicle Schedule
 */
export const copyVehicleScheduleOptions = (options: Options<CopyVehicleScheduleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await copyVehicleSchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: copyVehicleScheduleQueryKey(options),
  })
}

/**
 * Copy Vehicle Schedule
 */
export const copyVehicleScheduleMutation = (
  options?: Partial<Options<CopyVehicleScheduleData>>
): UseMutationOptions<CopyVehicleScheduleResponse, CopyVehicleScheduleError, Options<CopyVehicleScheduleData>> => {
  const mutationOptions: UseMutationOptions<
    CopyVehicleScheduleResponse,
    CopyVehicleScheduleError,
    Options<CopyVehicleScheduleData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await copyVehicleSchedule({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const scheduleDocumentationDayQueryKey = (options: Options<ScheduleDocumentationDayData>) =>
  createQueryKey('scheduleDocumentationDay', options)

/**
 * Schedule Documentation Day
 */
export const scheduleDocumentationDayOptions = (options: Options<ScheduleDocumentationDayData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await scheduleDocumentationDay({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: scheduleDocumentationDayQueryKey(options),
  })
}

/**
 * Schedule Documentation Day
 */
export const scheduleDocumentationDayMutation = (
  options?: Partial<Options<ScheduleDocumentationDayData>>
): UseMutationOptions<
  ScheduleDocumentationDayResponse,
  ScheduleDocumentationDayError,
  Options<ScheduleDocumentationDayData>
> => {
  const mutationOptions: UseMutationOptions<
    ScheduleDocumentationDayResponse,
    ScheduleDocumentationDayError,
    Options<ScheduleDocumentationDayData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await scheduleDocumentationDay({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const scheduleDocumentationMonthQueryKey = (options: Options<ScheduleDocumentationMonthData>) =>
  createQueryKey('scheduleDocumentationMonth', options)

/**
 * Schedule Documentation Month
 */
export const scheduleDocumentationMonthOptions = (options: Options<ScheduleDocumentationMonthData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await scheduleDocumentationMonth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: scheduleDocumentationMonthQueryKey(options),
  })
}

/**
 * Schedule Documentation Month
 */
export const scheduleDocumentationMonthMutation = (
  options?: Partial<Options<ScheduleDocumentationMonthData>>
): UseMutationOptions<
  ScheduleDocumentationMonthResponse,
  ScheduleDocumentationMonthError,
  Options<ScheduleDocumentationMonthData>
> => {
  const mutationOptions: UseMutationOptions<
    ScheduleDocumentationMonthResponse,
    ScheduleDocumentationMonthError,
    Options<ScheduleDocumentationMonthData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await scheduleDocumentationMonth({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const scheduleItstDayQueryKey = (options: Options<ScheduleItstDayData>) =>
  createQueryKey('scheduleItstDay', options)

/**
 * Schedule Itst Day
 */
export const scheduleItstDayOptions = (options: Options<ScheduleItstDayData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await scheduleItstDay({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: scheduleItstDayQueryKey(options),
  })
}

/**
 * Schedule Itst Day
 */
export const scheduleItstDayMutation = (
  options?: Partial<Options<ScheduleItstDayData>>
): UseMutationOptions<ScheduleItstDayResponse, ScheduleItstDayError, Options<ScheduleItstDayData>> => {
  const mutationOptions: UseMutationOptions<
    ScheduleItstDayResponse,
    ScheduleItstDayError,
    Options<ScheduleItstDayData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await scheduleItstDay({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const scheduleItstMonthQueryKey = (options: Options<ScheduleItstMonthData>) =>
  createQueryKey('scheduleItstMonth', options)

/**
 * Schedule Itst Month
 */
export const scheduleItstMonthOptions = (options: Options<ScheduleItstMonthData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await scheduleItstMonth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: scheduleItstMonthQueryKey(options),
  })
}

/**
 * Schedule Itst Month
 */
export const scheduleItstMonthMutation = (
  options?: Partial<Options<ScheduleItstMonthData>>
): UseMutationOptions<ScheduleItstMonthResponse, ScheduleItstMonthError, Options<ScheduleItstMonthData>> => {
  const mutationOptions: UseMutationOptions<
    ScheduleItstMonthResponse,
    ScheduleItstMonthError,
    Options<ScheduleItstMonthData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await scheduleItstMonth({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const applyDsPlanEndpointQueryKey = (options: Options<ApplyDsPlanEndpointData>) =>
  createQueryKey('applyDsPlanEndpoint', options)

/**
 * Apply Ds Plan Endpoint
 */
export const applyDsPlanEndpointOptions = (options: Options<ApplyDsPlanEndpointData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applyDsPlanEndpoint({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: applyDsPlanEndpointQueryKey(options),
  })
}

/**
 * Apply Ds Plan Endpoint
 */
export const applyDsPlanEndpointMutation = (
  options?: Partial<Options<ApplyDsPlanEndpointData>>
): UseMutationOptions<ApplyDsPlanEndpointResponse, ApplyDsPlanEndpointError, Options<ApplyDsPlanEndpointData>> => {
  const mutationOptions: UseMutationOptions<
    ApplyDsPlanEndpointResponse,
    ApplyDsPlanEndpointError,
    Options<ApplyDsPlanEndpointData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await applyDsPlanEndpoint({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDrivesByDateQueryKey = (options: Options<GetDrivesByDateData>) =>
  createQueryKey('getDrivesByDate', options)

/**
 * Get Drives By Date
 */
export const getDrivesByDateOptions = (options: Options<GetDrivesByDateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDrivesByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDrivesByDateQueryKey(options),
  })
}

export const getDailyDriveOverviewQueryKey = (options: Options<GetDailyDriveOverviewData>) =>
  createQueryKey('getDailyDriveOverview', options)

/**
 * Get Daily Drive Overview
 */
export const getDailyDriveOverviewOptions = (options: Options<GetDailyDriveOverviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDailyDriveOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDailyDriveOverviewQueryKey(options),
  })
}

export const getScheduledDriveStatisticsQueryKey = (options: Options<GetScheduledDriveStatisticsData>) =>
  createQueryKey('getScheduledDriveStatistics', options)

/**
 * Get Scheduled Drive Statistics
 * Get statistics of a single scheduled drive
 */
export const getScheduledDriveStatisticsOptions = (options: Options<GetScheduledDriveStatisticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScheduledDriveStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getScheduledDriveStatisticsQueryKey(options),
  })
}

export const getPackageSubmissionDetailQueryKey = (options: Options<GetPackageSubmissionDetailData>) =>
  createQueryKey('getPackageSubmissionDetail', options)

/**
 * Get Package Submission Detail
 * Get package submission statistics of a single scheduled drive
 */
export const getPackageSubmissionDetailOptions = (options: Options<GetPackageSubmissionDetailData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPackageSubmissionDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPackageSubmissionDetailQueryKey(options),
  })
}

export const getDetailedDriveStatisticsQueryKey = (options: Options<GetDetailedDriveStatisticsData>) =>
  createQueryKey('getDetailedDriveStatistics', options)

/**
 * Get Detailed Drive Statistics
 */
export const getDetailedDriveStatisticsOptions = (options: Options<GetDetailedDriveStatisticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDetailedDriveStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDetailedDriveStatisticsQueryKey(options),
  })
}

export const getDriverStatisticsQueryKey = (options: Options<GetDriverStatisticsData>) =>
  createQueryKey('getDriverStatistics', options)

/**
 * Get Driver Statistics
 */
export const getDriverStatisticsOptions = (options: Options<GetDriverStatisticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriverStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDriverStatisticsQueryKey(options),
  })
}

export const getElapsedDriverTimeQueryKey = (options: Options<GetElapsedDriverTimeData>) =>
  createQueryKey('getElapsedDriverTime', options)

/**
 * Get Elapsed Driver Time
 */
export const getElapsedDriverTimeOptions = (options: Options<GetElapsedDriverTimeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getElapsedDriverTime({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getElapsedDriverTimeQueryKey(options),
  })
}

export const getAllRouteStatisticsQueryKey = (options?: Options<GetAllRouteStatisticsData>) =>
  createQueryKey('getAllRouteStatistics', options)

/**
 * Get All Route Statistics
 */
export const getAllRouteStatisticsOptions = (options?: Options<GetAllRouteStatisticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllRouteStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllRouteStatisticsQueryKey(options),
  })
}

export const getDistrictOverheadStatisticsQueryKey = (options: Options<GetDistrictOverheadStatisticsData>) =>
  createQueryKey('getDistrictOverheadStatistics', options)

/**
 * Get District Overhead Statistics
 */
export const getDistrictOverheadStatisticsOptions = (options: Options<GetDistrictOverheadStatisticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDistrictOverheadStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDistrictOverheadStatisticsQueryKey(options),
  })
}

export const getRouteStatisticsQueryKey = (options: Options<GetRouteStatisticsData>) =>
  createQueryKey('getRouteStatistics', options)

/**
 * Get Route Statistics
 */
export const getRouteStatisticsOptions = (options: Options<GetRouteStatisticsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRouteStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRouteStatisticsQueryKey(options),
  })
}

export const getOperationMetricsQueryKey = (options: Options<GetOperationMetricsData>) =>
  createQueryKey('getOperationMetrics', options)

/**
 * Get Operation Metrics
 */
export const getOperationMetricsOptions = (options: Options<GetOperationMetricsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOperationMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOperationMetricsQueryKey(options),
  })
}

export const getOperationReportDriversQueryKey = (options: Options<GetOperationReportDriversData>) =>
  createQueryKey('getOperationReportDrivers', options)

/**
 * Get Operation Report Drivers
 */
export const getOperationReportDriversOptions = (options: Options<GetOperationReportDriversData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOperationReportDrivers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOperationReportDriversQueryKey(options),
  })
}

export const getOperationReportRoutesQueryKey = (options: Options<GetOperationReportRoutesData>) =>
  createQueryKey('getOperationReportRoutes', options)

/**
 * Get Operation Report Routes
 */
export const getOperationReportRoutesOptions = (options: Options<GetOperationReportRoutesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOperationReportRoutes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getOperationReportRoutesQueryKey(options),
  })
}

export const getDetectionComparisonFirstDrivesQueryKey = (options?: Options<GetDetectionComparisonFirstDrivesData>) =>
  createQueryKey('getDetectionComparisonFirstDrives', options)

/**
 * Get Detection Comparison First Drives
 * List drives selectable as the first drive of a detection comparison
 */
export const getDetectionComparisonFirstDrivesOptions = (options?: Options<GetDetectionComparisonFirstDrivesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDetectionComparisonFirstDrives({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDetectionComparisonFirstDrivesQueryKey(options),
  })
}

export const getDetectionComparisonFirstDrivesInfiniteQueryKey = (
  options?: Options<GetDetectionComparisonFirstDrivesData>
): QueryKey<Options<GetDetectionComparisonFirstDrivesData>> =>
  createQueryKey('getDetectionComparisonFirstDrives', options, true)

/**
 * Get Detection Comparison First Drives
 * List drives selectable as the first drive of a detection comparison
 */
export const getDetectionComparisonFirstDrivesInfiniteOptions = (
  options?: Options<GetDetectionComparisonFirstDrivesData>
) => {
  return infiniteQueryOptions<
    GetDetectionComparisonFirstDrivesResponse,
    GetDetectionComparisonFirstDrivesError,
    InfiniteData<GetDetectionComparisonFirstDrivesResponse>,
    QueryKey<Options<GetDetectionComparisonFirstDrivesData>>,
    number | Pick<QueryKey<Options<GetDetectionComparisonFirstDrivesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetDetectionComparisonFirstDrivesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getDetectionComparisonFirstDrives({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getDetectionComparisonFirstDrivesInfiniteQueryKey(options),
    }
  )
}

export const getDetectionComparisonSecondDrivesQueryKey = (options: Options<GetDetectionComparisonSecondDrivesData>) =>
  createQueryKey('getDetectionComparisonSecondDrives', options)

/**
 * Get Detection Comparison Second Drives
 * List drives of the first drive's route selectable as the second drive of a detection comparison
 */
export const getDetectionComparisonSecondDrivesOptions = (options: Options<GetDetectionComparisonSecondDrivesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDetectionComparisonSecondDrives({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDetectionComparisonSecondDrivesQueryKey(options),
  })
}

export const getDetectionComparisonSecondDrivesInfiniteQueryKey = (
  options: Options<GetDetectionComparisonSecondDrivesData>
): QueryKey<Options<GetDetectionComparisonSecondDrivesData>> =>
  createQueryKey('getDetectionComparisonSecondDrives', options, true)

/**
 * Get Detection Comparison Second Drives
 * List drives of the first drive's route selectable as the second drive of a detection comparison
 */
export const getDetectionComparisonSecondDrivesInfiniteOptions = (
  options: Options<GetDetectionComparisonSecondDrivesData>
) => {
  return infiniteQueryOptions<
    GetDetectionComparisonSecondDrivesResponse,
    GetDetectionComparisonSecondDrivesError,
    InfiniteData<GetDetectionComparisonSecondDrivesResponse>,
    QueryKey<Options<GetDetectionComparisonSecondDrivesData>>,
    number | Pick<QueryKey<Options<GetDetectionComparisonSecondDrivesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetDetectionComparisonSecondDrivesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getDetectionComparisonSecondDrives({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getDetectionComparisonSecondDrivesInfiniteQueryKey(options),
    }
  )
}

export const getDetectionComparisonQueryKey = (options: Options<GetDetectionComparisonData>) =>
  createQueryKey('getDetectionComparison', options)

/**
 * Get Detection Comparison
 * Match vehicle detections of two drives by plate and position
 */
export const getDetectionComparisonOptions = (options: Options<GetDetectionComparisonData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDetectionComparison({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDetectionComparisonQueryKey(options),
  })
}

export const getDriveEventsQueryKey = (options: Options<GetDriveEventsData>) =>
  createQueryKey('getDriveEvents', options)

/**
 * Get Drive Events
 */
export const getDriveEventsOptions = (options: Options<GetDriveEventsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriveEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDriveEventsQueryKey(options),
  })
}

export const getDrivenStreetSegmentsQueryKey = (options: Options<GetDrivenStreetSegmentsData>) =>
  createQueryKey('getDrivenStreetSegments', options)

/**
 * Get Driven Street Segments
 */
export const getDrivenStreetSegmentsOptions = (options: Options<GetDrivenStreetSegmentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDrivenStreetSegments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDrivenStreetSegmentsQueryKey(options),
  })
}

export const getParkingSignDetectionCountQueryKey = (options: Options<GetParkingSignDetectionCountData>) =>
  createQueryKey('getParkingSignDetectionCount', options)

/**
 * Get Parking Sign Detection Count
 */
export const getParkingSignDetectionCountOptions = (options: Options<GetParkingSignDetectionCountData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getParkingSignDetectionCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getParkingSignDetectionCountQueryKey(options),
  })
}

export const getTechnicalSegmentDetectionCountQueryKey = (options: Options<GetTechnicalSegmentDetectionCountData>) =>
  createQueryKey('getTechnicalSegmentDetectionCount', options)

/**
 * Get Technical Segment Detection Count
 */
export const getTechnicalSegmentDetectionCountOptions = (options: Options<GetTechnicalSegmentDetectionCountData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTechnicalSegmentDetectionCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTechnicalSegmentDetectionCountQueryKey(options),
  })
}

export const getDocumentationOverviewQueryKey = (options: Options<GetDocumentationOverviewData>) =>
  createQueryKey('getDocumentationOverview', options)

/**
 * Get Documentation Overview
 */
export const getDocumentationOverviewOptions = (options: Options<GetDocumentationOverviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDocumentationOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDocumentationOverviewQueryKey(options),
  })
}

export const getSignPostConfidencesQueryKey = (options: Options<GetSignPostConfidencesData>) =>
  createQueryKey('getSignPostConfidences', options)

/**
 * Get Sign Post Confidences
 * Best image confidence statistics of sign post detections observed in [timestamp_from, timestamp_to),
 * split by camera mode (day/night). Sign posts from the control data that were not detected are included
 * with zero detection count.
 */
export const getSignPostConfidencesOptions = (options: Options<GetSignPostConfidencesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSignPostConfidences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSignPostConfidencesQueryKey(options),
  })
}

export const getTasksQueryKey = (options?: Options<GetTasksData>) => createQueryKey('getTasks', options)

/**
 * Get Tasks
 */
export const getTasksOptions = (options?: Options<GetTasksData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTasksQueryKey(options),
  })
}

export const getTasksForIntervalQueryKey = (options: Options<GetTasksForIntervalData>) =>
  createQueryKey('getTasksForInterval', options)

/**
 * Get Tasks For Interval
 */
export const getTasksForIntervalOptions = (options: Options<GetTasksForIntervalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTasksForInterval({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTasksForIntervalQueryKey(options),
  })
}

export const getAllBillingPeriodsQueryKey = (options?: Options<GetAllBillingPeriodsData>) =>
  createQueryKey('getAllBillingPeriods', options)

/**
 * Get All Billing Periods
 */
export const getAllBillingPeriodsOptions = (options?: Options<GetAllBillingPeriodsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllBillingPeriods({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllBillingPeriodsQueryKey(options),
  })
}

export const createBillingPeriodQueryKey = (options: Options<CreateBillingPeriodData>) =>
  createQueryKey('createBillingPeriod', options)

/**
 * Create Billing Period
 */
export const createBillingPeriodOptions = (options: Options<CreateBillingPeriodData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createBillingPeriod({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createBillingPeriodQueryKey(options),
  })
}

/**
 * Create Billing Period
 */
export const createBillingPeriodMutation = (
  options?: Partial<Options<CreateBillingPeriodData>>
): UseMutationOptions<CreateBillingPeriodResponse, CreateBillingPeriodError, Options<CreateBillingPeriodData>> => {
  const mutationOptions: UseMutationOptions<
    CreateBillingPeriodResponse,
    CreateBillingPeriodError,
    Options<CreateBillingPeriodData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await createBillingPeriod({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getTaskBillingPeriodsQueryKey = (options: Options<GetTaskBillingPeriodsData>) =>
  createQueryKey('getTaskBillingPeriods', options)

/**
 * Get Task Billing Periods
 */
export const getTaskBillingPeriodsOptions = (options: Options<GetTaskBillingPeriodsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTaskBillingPeriods({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTaskBillingPeriodsQueryKey(options),
  })
}

/**
 * Delete Billing Period
 */
export const deleteBillingPeriodMutation = (
  options?: Partial<Options<DeleteBillingPeriodData>>
): UseMutationOptions<DeleteBillingPeriodResponse, DeleteBillingPeriodError, Options<DeleteBillingPeriodData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteBillingPeriodResponse,
    DeleteBillingPeriodError,
    Options<DeleteBillingPeriodData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteBillingPeriod({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getBillingPeriodDetailQueryKey = (options: Options<GetBillingPeriodDetailData>) =>
  createQueryKey('getBillingPeriodDetail', options)

/**
 * Get Billing Period Detail
 */
export const getBillingPeriodDetailOptions = (options: Options<GetBillingPeriodDetailData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBillingPeriodDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBillingPeriodDetailQueryKey(options),
  })
}

/**
 * Update Billing Period
 */
export const updateBillingPeriodMutation = (
  options?: Partial<Options<UpdateBillingPeriodData>>
): UseMutationOptions<UpdateBillingPeriodResponse, UpdateBillingPeriodError, Options<UpdateBillingPeriodData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateBillingPeriodResponse,
    UpdateBillingPeriodError,
    Options<UpdateBillingPeriodData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateBillingPeriod({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Update Billing Period Prices
 */
export const updateBillingPeriodPricesMutation = (
  options?: Partial<Options<UpdateBillingPeriodPricesData>>
): UseMutationOptions<
  UpdateBillingPeriodPricesResponse,
  UpdateBillingPeriodPricesError,
  Options<UpdateBillingPeriodPricesData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateBillingPeriodPricesResponse,
    UpdateBillingPeriodPricesError,
    Options<UpdateBillingPeriodPricesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await updateBillingPeriodPrices({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const importOrderQueryKey = (options: Options<ImportOrderData>) => createQueryKey('importOrder', options)

/**
 * Import Order
 */
export const importOrderOptions = (options: Options<ImportOrderData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await importOrder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: importOrderQueryKey(options),
  })
}

/**
 * Import Order
 */
export const importOrderMutation = (
  options?: Partial<Options<ImportOrderData>>
): UseMutationOptions<ImportOrderResponse2, ImportOrderError2, Options<ImportOrderData>> => {
  const mutationOptions: UseMutationOptions<ImportOrderResponse2, ImportOrderError2, Options<ImportOrderData>> = {
    mutationFn: async localOptions => {
      const { data } = await importOrder({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getDriveBillingDataQueryKey = (options: Options<GetDriveBillingDataData>) =>
  createQueryKey('getDriveBillingData', options)

/**
 * Get Drive Billing Data
 */
export const getDriveBillingDataOptions = (options: Options<GetDriveBillingDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriveBillingData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDriveBillingDataQueryKey(options),
  })
}

export const getBillingAuditDataQueryKey = (options: Options<GetBillingAuditDataData>) =>
  createQueryKey('getBillingAuditData', options)

/**
 * Get Billing Audit Data
 */
export const getBillingAuditDataOptions = (options: Options<GetBillingAuditDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBillingAuditData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBillingAuditDataQueryKey(options),
  })
}

export const getBilledAmountHistoryQueryKey = (options: Options<GetBilledAmountHistoryData>) =>
  createQueryKey('getBilledAmountHistory', options)

/**
 * Get Billed Amount History
 */
export const getBilledAmountHistoryOptions = (options: Options<GetBilledAmountHistoryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBilledAmountHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBilledAmountHistoryQueryKey(options),
  })
}

export const getInvoiceDetailQueryKey = (options: Options<GetInvoiceDetailData>) =>
  createQueryKey('getInvoiceDetail', options)

/**
 * Get Invoice Detail
 */
export const getInvoiceDetailOptions = (options: Options<GetInvoiceDetailData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInvoiceDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getInvoiceDetailQueryKey(options),
  })
}

export const getInvoiceDetailCsvQueryKey = (options: Options<GetInvoiceDetailCsvData>) =>
  createQueryKey('getInvoiceDetailCsv', options)

/**
 * Get Invoice Detail Csv
 */
export const getInvoiceDetailCsvOptions = (options: Options<GetInvoiceDetailCsvData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInvoiceDetailCsv({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getInvoiceDetailCsvQueryKey(options),
  })
}

export const getInvoiceCsvQueryKey = (options: Options<GetInvoiceCsvData>) => createQueryKey('getInvoiceCsv', options)

/**
 * Get Invoice Csv
 */
export const getInvoiceCsvOptions = (options: Options<GetInvoiceCsvData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInvoiceCsv({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getInvoiceCsvQueryKey(options),
  })
}

export const getInvoiceCsvTotalsQueryKey = (options: Options<GetInvoiceCsvTotalsData>) =>
  createQueryKey('getInvoiceCsvTotals', options)

/**
 * Get Invoice Csv Totals
 */
export const getInvoiceCsvTotalsOptions = (options: Options<GetInvoiceCsvTotalsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInvoiceCsvTotals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getInvoiceCsvTotalsQueryKey(options),
  })
}

export const getStreetSegmentAuditDataQueryKey = (options: Options<GetStreetSegmentAuditDataData>) =>
  createQueryKey('getStreetSegmentAuditData', options)

/**
 * Get Street Segment Audit Data
 */
export const getStreetSegmentAuditDataOptions = (options: Options<GetStreetSegmentAuditDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStreetSegmentAuditData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getStreetSegmentAuditDataQueryKey(options),
  })
}

export const getTechnicalSegmentAuditDataQueryKey = (options: Options<GetTechnicalSegmentAuditDataData>) =>
  createQueryKey('getTechnicalSegmentAuditData', options)

/**
 * Get Technical Segment Audit Data
 */
export const getTechnicalSegmentAuditDataOptions = (options: Options<GetTechnicalSegmentAuditDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTechnicalSegmentAuditData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTechnicalSegmentAuditDataQueryKey(options),
  })
}

export const getInvoiceAttachmentZipQueryKey = (options: Options<GetInvoiceAttachmentZipData>) =>
  createQueryKey('getInvoiceAttachmentZip', options)

/**
 * Get Invoice Attachment Zip
 */
export const getInvoiceAttachmentZipOptions = (options: Options<GetInvoiceAttachmentZipData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInvoiceAttachmentZip({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getInvoiceAttachmentZipQueryKey(options),
  })
}

export const getMetricsQueryKey = (options?: Options<GetMetricsData>) => createQueryKey('getMetrics', options)

/**
 * Get Metrics
 * Retrieve Prometheus metrics
 */
export const getMetricsOptions = (options?: Options<GetMetricsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getMetricsQueryKey(options),
  })
}

export const checkHealthQueryKey = (options?: Options<CheckHealthData>) => createQueryKey('checkHealth', options)

/**
 * Check Health
 */
export const checkHealthOptions = (options?: Options<CheckHealthData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await checkHealth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: checkHealthQueryKey(options),
  })
}

export const authenticateUserQueryKey = (options: Options<AuthenticateUserData>) =>
  createQueryKey('authenticateUser', options)

/**
 * Authenticate User
 */
export const authenticateUserOptions = (options: Options<AuthenticateUserData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authenticateUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: authenticateUserQueryKey(options),
  })
}

/**
 * Authenticate User
 */
export const authenticateUserMutation = (
  options?: Partial<Options<AuthenticateUserData>>
): UseMutationOptions<AuthenticateUserResponse, AuthenticateUserError, Options<AuthenticateUserData>> => {
  const mutationOptions: UseMutationOptions<
    AuthenticateUserResponse,
    AuthenticateUserError,
    Options<AuthenticateUserData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await authenticateUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const refreshTokenQueryKey = (options?: Options<RefreshTokenData>) => createQueryKey('refreshToken', options)

/**
 * Refresh Token
 */
export const refreshTokenOptions = (options?: Options<RefreshTokenData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await refreshToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: refreshTokenQueryKey(options),
  })
}

/**
 * Refresh Token
 */
export const refreshTokenMutation = (
  options?: Partial<Options<RefreshTokenData>>
): UseMutationOptions<RefreshTokenResponse, RefreshTokenError, Options<RefreshTokenData>> => {
  const mutationOptions: UseMutationOptions<RefreshTokenResponse, RefreshTokenError, Options<RefreshTokenData>> = {
    mutationFn: async localOptions => {
      const { data } = await refreshToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const introspectUserQueryKey = (options?: Options<IntrospectUserData>) =>
  createQueryKey('introspectUser', options)

/**
 * Introspect User
 */
export const introspectUserOptions = (options?: Options<IntrospectUserData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await introspectUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: introspectUserQueryKey(options),
  })
}

export const changeOwnPasswordQueryKey = (options: Options<ChangeOwnPasswordData>) =>
  createQueryKey('changeOwnPassword', options)

/**
 * Change Own Password
 */
export const changeOwnPasswordOptions = (options: Options<ChangeOwnPasswordData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await changeOwnPassword({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: changeOwnPasswordQueryKey(options),
  })
}

/**
 * Change Own Password
 */
export const changeOwnPasswordMutation = (
  options?: Partial<Options<ChangeOwnPasswordData>>
): UseMutationOptions<ChangeOwnPasswordResponse, ChangeOwnPasswordError, Options<ChangeOwnPasswordData>> => {
  const mutationOptions: UseMutationOptions<
    ChangeOwnPasswordResponse,
    ChangeOwnPasswordError,
    Options<ChangeOwnPasswordData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await changeOwnPassword({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const logEvidenceSubmissionQueryKey = (options: Options<LogEvidenceSubmissionData>) =>
  createQueryKey('logEvidenceSubmission', options)

/**
 * Log Evidence Submission
 */
export const logEvidenceSubmissionOptions = (options: Options<LogEvidenceSubmissionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await logEvidenceSubmission({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: logEvidenceSubmissionQueryKey(options),
  })
}

/**
 * Log Evidence Submission
 */
export const logEvidenceSubmissionMutation = (
  options?: Partial<Options<LogEvidenceSubmissionData>>
): UseMutationOptions<
  LogEvidenceSubmissionResponse,
  LogEvidenceSubmissionError,
  Options<LogEvidenceSubmissionData>
> => {
  const mutationOptions: UseMutationOptions<
    LogEvidenceSubmissionResponse,
    LogEvidenceSubmissionError,
    Options<LogEvidenceSubmissionData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await logEvidenceSubmission({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getEventPayloadQueryKey = (options: Options<GetEventPayloadData>) =>
  createQueryKey('getEventPayload', options)

/**
 * Get Event Payload
 */
export const getEventPayloadOptions = (options: Options<GetEventPayloadData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEventPayload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getEventPayloadQueryKey(options),
  })
}

export const getPackageScoresQueryKey = (options: Options<GetPackageScoresData>) =>
  createQueryKey('getPackageScores', options)

/**
 * Get Package Scores
 */
export const getPackageScoresOptions = (options: Options<GetPackageScoresData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPackageScores({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPackageScoresQueryKey(options),
  })
}

export const getPassRequestQueryKey = (options?: Options<GetPassRequestData>) =>
  createQueryKey('getPassRequest', options)

/**
 * Get Pass Request
 */
export const getPassRequestOptions = (options?: Options<GetPassRequestData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPassRequest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPassRequestQueryKey(options),
  })
}

export const resubmitEventsQueryKey = (options: Options<ResubmitEventsData>) =>
  createQueryKey('resubmitEvents', options)

/**
 * Resubmit Events
 * Time limits form a open-close interval (received_after inclusive, received_before exclusive).
 * Both status code limits are inclusive.
 */
export const resubmitEventsOptions = (options: Options<ResubmitEventsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resubmitEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: resubmitEventsQueryKey(options),
  })
}

/**
 * Resubmit Events
 * Time limits form a open-close interval (received_after inclusive, received_before exclusive).
 * Both status code limits are inclusive.
 */
export const resubmitEventsMutation = (
  options?: Partial<Options<ResubmitEventsData>>
): UseMutationOptions<ResubmitEventsResponse2, ResubmitEventsError, Options<ResubmitEventsData>> => {
  const mutationOptions: UseMutationOptions<
    ResubmitEventsResponse2,
    ResubmitEventsError,
    Options<ResubmitEventsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await resubmitEvents({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deprecatedGetMapSchemaSnapshotVersionQueryKey = (
  options: Options<DeprecatedGetMapSchemaSnapshotVersionData>
) => createQueryKey('deprecatedGetMapSchemaSnapshotVersion', options)

/**
 * [Deprecated] Get Map Schema Snapshot Version
 * @deprecated
 */
export const deprecatedGetMapSchemaSnapshotVersionOptions = (
  options: Options<DeprecatedGetMapSchemaSnapshotVersionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deprecatedGetMapSchemaSnapshotVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: deprecatedGetMapSchemaSnapshotVersionQueryKey(options),
  })
}

export const getControlDataVersionQueryKey = (options: Options<GetControlDataVersionData>) =>
  createQueryKey('getControlDataVersion', options)

/**
 * Get Control Data Version
 */
export const getControlDataVersionOptions = (options: Options<GetControlDataVersionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControlDataVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getControlDataVersionQueryKey(options),
  })
}

export const getControlDataContentsQueryKey = (options: Options<GetControlDataContentsData>) =>
  createQueryKey('getControlDataContents', options)

/**
 * Get Control Data Contents
 */
export const getControlDataContentsOptions = (options: Options<GetControlDataContentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControlDataContents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getControlDataContentsQueryKey(options),
  })
}

export const deprecatedGetMapSchemaContentsQueryKey = (options: Options<DeprecatedGetMapSchemaContentsData>) =>
  createQueryKey('deprecatedGetMapSchemaContents', options)

/**
 * [Deprecated] Get Map Schema Contents
 * @deprecated
 */
export const deprecatedGetMapSchemaContentsOptions = (options: Options<DeprecatedGetMapSchemaContentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deprecatedGetMapSchemaContents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: deprecatedGetMapSchemaContentsQueryKey(options),
  })
}

export const getAllUnexpectedEventsQueryKey = (options?: Options<GetAllUnexpectedEventsData>) =>
  createQueryKey('getAllUnexpectedEvents', options)

/**
 * Get All Unexpected Events
 * Get all UEs, but not those, that have no latitude/longitude in `patrol_vehicle.position`.
 */
export const getAllUnexpectedEventsOptions = (options?: Options<GetAllUnexpectedEventsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllUnexpectedEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllUnexpectedEventsQueryKey(options),
  })
}

export const getPendingUnexpectedEventsQueryKey = (options?: Options<GetPendingUnexpectedEventsData>) =>
  createQueryKey('getPendingUnexpectedEvents', options)

/**
 * Get Pending Unexpected Events
 * Get all pending UEs, but not those, that have no latitude/longitude in `patrol_vehicle.position`.
 */
export const getPendingUnexpectedEventsOptions = (options?: Options<GetPendingUnexpectedEventsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPendingUnexpectedEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPendingUnexpectedEventsQueryKey(options),
  })
}

export const getArchivedUnexpectedEventsQueryKey = (options?: Options<GetArchivedUnexpectedEventsData>) =>
  createQueryKey('getArchivedUnexpectedEvents', options)

/**
 * Get Archived Unexpected Events
 * Get all processed/archived UEs, but not those, that have no latitude/longitude in `patrol_vehicle.position`.
 */
export const getArchivedUnexpectedEventsOptions = (options?: Options<GetArchivedUnexpectedEventsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getArchivedUnexpectedEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getArchivedUnexpectedEventsQueryKey(options),
  })
}

export const getUnexpectedEventCameraCapturesQueryKey = (options: Options<GetUnexpectedEventCameraCapturesData>) =>
  createQueryKey('getUnexpectedEventCameraCaptures', options)

/**
 * Get Unexpected Event Camera Captures
 */
export const getUnexpectedEventCameraCapturesOptions = (options: Options<GetUnexpectedEventCameraCapturesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUnexpectedEventCameraCaptures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUnexpectedEventCameraCapturesQueryKey(options),
  })
}

export const getUnexpectedEventDetailsQueryKey = (options: Options<GetUnexpectedEventDetailsData>) =>
  createQueryKey('getUnexpectedEventDetails', options)

/**
 * Get Unexpected Event Details
 */
export const getUnexpectedEventDetailsOptions = (options: Options<GetUnexpectedEventDetailsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUnexpectedEventDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUnexpectedEventDetailsQueryKey(options),
  })
}

export const getAnnexationsForDayQueryKey = (options: Options<GetAnnexationsForDayData>) =>
  createQueryKey('getAnnexationsForDay', options)

/**
 * Get Annexations For Day
 */
export const getAnnexationsForDayOptions = (options: Options<GetAnnexationsForDayData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAnnexationsForDay({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAnnexationsForDayQueryKey(options),
  })
}

export const resolveUnexpectedEventQueryKey = (options: Options<ResolveUnexpectedEventData>) =>
  createQueryKey('resolveUnexpectedEvent', options)

/**
 * Resolve Unexpected Event
 */
export const resolveUnexpectedEventOptions = (options: Options<ResolveUnexpectedEventData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resolveUnexpectedEvent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: resolveUnexpectedEventQueryKey(options),
  })
}

/**
 * Resolve Unexpected Event
 */
export const resolveUnexpectedEventMutation = (
  options?: Partial<Options<ResolveUnexpectedEventData>>
): UseMutationOptions<unknown, ResolveUnexpectedEventError, Options<ResolveUnexpectedEventData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ResolveUnexpectedEventError,
    Options<ResolveUnexpectedEventData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await resolveUnexpectedEvent({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const unresolveUnexpectedEventQueryKey = (options: Options<UnresolveUnexpectedEventData>) =>
  createQueryKey('unresolveUnexpectedEvent', options)

/**
 * Unresolve Unexpected Event
 */
export const unresolveUnexpectedEventOptions = (options: Options<UnresolveUnexpectedEventData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await unresolveUnexpectedEvent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: unresolveUnexpectedEventQueryKey(options),
  })
}

/**
 * Unresolve Unexpected Event
 */
export const unresolveUnexpectedEventMutation = (
  options?: Partial<Options<UnresolveUnexpectedEventData>>
): UseMutationOptions<unknown, UnresolveUnexpectedEventError, Options<UnresolveUnexpectedEventData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UnresolveUnexpectedEventError,
    Options<UnresolveUnexpectedEventData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await unresolveUnexpectedEvent({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAffectedRoutesQueryKey = (options: Options<GetAffectedRoutesData>) =>
  createQueryKey('getAffectedRoutes', options)

/**
 * Get Affected Routes
 * Endpoint for returning all routes, that contains any of given route segments.
 *
 * Used in unexpected events.
 */
export const getAffectedRoutesOptions = (options: Options<GetAffectedRoutesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAffectedRoutes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAffectedRoutesQueryKey(options),
  })
}

/**
 * Get Affected Routes
 * Endpoint for returning all routes, that contains any of given route segments.
 *
 * Used in unexpected events.
 */
export const getAffectedRoutesMutation = (
  options?: Partial<Options<GetAffectedRoutesData>>
): UseMutationOptions<GetAffectedRoutesResponse, GetAffectedRoutesError, Options<GetAffectedRoutesData>> => {
  const mutationOptions: UseMutationOptions<
    GetAffectedRoutesResponse,
    GetAffectedRoutesError,
    Options<GetAffectedRoutesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await getAffectedRoutes({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getEnvInfoQueryKey = (options?: Options<GetEnvInfoData>) => createQueryKey('getEnvInfo', options)

/**
 * Get Env Info
 */
export const getEnvInfoOptions = (options?: Options<GetEnvInfoData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnvInfo({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getEnvInfoQueryKey(options),
  })
}

export const cleanCacheQueryKey = (options?: Options<CleanCacheData>) => createQueryKey('cleanCache', options)

/**
 * Clean Cache
 */
export const cleanCacheOptions = (options?: Options<CleanCacheData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await cleanCache({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: cleanCacheQueryKey(options),
  })
}

export const cleanBillingCacheQueryKey = (options?: Options<CleanBillingCacheData>) =>
  createQueryKey('cleanBillingCache', options)

/**
 * Clean Billing Cache
 */
export const cleanBillingCacheOptions = (options?: Options<CleanBillingCacheData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await cleanBillingCache({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: cleanBillingCacheQueryKey(options),
  })
}

export const getHotlineCallsQueryKey = (options: Options<GetHotlineCallsData>) =>
  createQueryKey('getHotlineCalls', options)

/**
 * Get Hotline Calls
 */
export const getHotlineCallsOptions = (options: Options<GetHotlineCallsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHotlineCalls({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getHotlineCallsQueryKey(options),
  })
}

export const getChunksQueryKey = (options?: Options<GetChunksData>) => createQueryKey('getChunks', options)

/**
 * Get Chunks
 */
export const getChunksOptions = (options?: Options<GetChunksData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChunks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getChunksQueryKey(options),
  })
}

export const getChunkDetailQueryKey = (options: Options<GetChunkDetailData>) =>
  createQueryKey('getChunkDetail', options)

/**
 * Get Chunk Detail
 */
export const getChunkDetailOptions = (options: Options<GetChunkDetailData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChunkDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getChunkDetailQueryKey(options),
  })
}

export const postChunkQualityQueryKey = (options: Options<PostChunkQualityData>) =>
  createQueryKey('postChunkQuality', options)

/**
 * Post Chunk Quality
 */
export const postChunkQualityOptions = (options: Options<PostChunkQualityData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postChunkQuality({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postChunkQualityQueryKey(options),
  })
}

/**
 * Post Chunk Quality
 */
export const postChunkQualityMutation = (
  options?: Partial<Options<PostChunkQualityData>>
): UseMutationOptions<PostChunkQualityResponse, PostChunkQualityError, Options<PostChunkQualityData>> => {
  const mutationOptions: UseMutationOptions<
    PostChunkQualityResponse,
    PostChunkQualityError,
    Options<PostChunkQualityData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postChunkQuality({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getImageQueryKey = (options: Options<GetImageData>) => createQueryKey('getImage', options)

/**
 * Get Image
 */
export const getImageOptions = (options: Options<GetImageData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getImageQueryKey(options),
  })
}

export const getReportCsvQueryKey = (options: Options<GetReportCsvData>) => createQueryKey('getReportCsv', options)

/**
 * Get Report Csv
 */
export const getReportCsvOptions = (options: Options<GetReportCsvData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReportCsv({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getReportCsvQueryKey(options),
  })
}

export const listRolesQueryKey = (options?: Options<ListRolesData>) => createQueryKey('listRoles', options)

/**
 * List Roles
 */
export const listRolesOptions = (options?: Options<ListRolesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRoles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listRolesQueryKey(options),
  })
}

export const createRoleQueryKey = (options: Options<CreateRoleData>) => createQueryKey('createRole', options)

/**
 * Create Role
 */
export const createRoleOptions = (options: Options<CreateRoleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createRole({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createRoleQueryKey(options),
  })
}

/**
 * Create Role
 */
export const createRoleMutation = (
  options?: Partial<Options<CreateRoleData>>
): UseMutationOptions<CreateRoleResponse, CreateRoleError, Options<CreateRoleData>> => {
  const mutationOptions: UseMutationOptions<CreateRoleResponse, CreateRoleError, Options<CreateRoleData>> = {
    mutationFn: async localOptions => {
      const { data } = await createRole({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Role
 */
export const deleteRoleMutation = (
  options?: Partial<Options<DeleteRoleData>>
): UseMutationOptions<DeleteRoleResponse, DeleteRoleError, Options<DeleteRoleData>> => {
  const mutationOptions: UseMutationOptions<DeleteRoleResponse, DeleteRoleError, Options<DeleteRoleData>> = {
    mutationFn: async localOptions => {
      const { data } = await deleteRole({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getRoleQueryKey = (options: Options<GetRoleData>) => createQueryKey('getRole', options)

/**
 * Get Role
 */
export const getRoleOptions = (options: Options<GetRoleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRole({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRoleQueryKey(options),
  })
}

/**
 * Update Role
 */
export const updateRoleMutation = (
  options?: Partial<Options<UpdateRoleData>>
): UseMutationOptions<UpdateRoleResponse, UpdateRoleError, Options<UpdateRoleData>> => {
  const mutationOptions: UseMutationOptions<UpdateRoleResponse, UpdateRoleError, Options<UpdateRoleData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateRole({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listUsersQueryKey = (options?: Options<ListUsersData>) => createQueryKey('listUsers', options)

/**
 * List Users
 */
export const listUsersOptions = (options?: Options<ListUsersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listUsersQueryKey(options),
  })
}

export const createUserQueryKey = (options: Options<CreateUserData>) => createQueryKey('createUser', options)

/**
 * Create User
 */
export const createUserOptions = (options: Options<CreateUserData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createUserQueryKey(options),
  })
}

/**
 * Create User
 */
export const createUserMutation = (
  options?: Partial<Options<CreateUserData>>
): UseMutationOptions<CreateUserResponse, CreateUserError, Options<CreateUserData>> => {
  const mutationOptions: UseMutationOptions<CreateUserResponse, CreateUserError, Options<CreateUserData>> = {
    mutationFn: async localOptions => {
      const { data } = await createUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete User
 */
export const deleteUserMutation = (
  options?: Partial<Options<DeleteUserData>>
): UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> => {
  const mutationOptions: UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> = {
    mutationFn: async localOptions => {
      const { data } = await deleteUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getUserQueryKey = (options: Options<GetUserData>) => createQueryKey('getUser', options)

/**
 * Get User
 */
export const getUserOptions = (options: Options<GetUserData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUserQueryKey(options),
  })
}

/**
 * Update User
 */
export const updateUserMutation = (
  options?: Partial<Options<UpdateUserData>>
): UseMutationOptions<UpdateUserResponse, UpdateUserError, Options<UpdateUserData>> => {
  const mutationOptions: UseMutationOptions<UpdateUserResponse, UpdateUserError, Options<UpdateUserData>> = {
    mutationFn: async localOptions => {
      const { data } = await updateUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const pushReportQueryKey = (options: Options<PushReportData>) => createQueryKey('pushReport', options)

/**
 * Push Report
 */
export const pushReportOptions = (options: Options<PushReportData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pushReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: pushReportQueryKey(options),
  })
}

/**
 * Push Report
 */
export const pushReportMutation = (
  options?: Partial<Options<PushReportData>>
): UseMutationOptions<PushReportResponse, PushReportError, Options<PushReportData>> => {
  const mutationOptions: UseMutationOptions<PushReportResponse, PushReportError, Options<PushReportData>> = {
    mutationFn: async localOptions => {
      const { data } = await pushReport({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}
